'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.groups = exports.webSystemTrafficOutline = exports.webSystemTrafficFilled = exports.webSystemTouchOutline = exports.webSystemTerminalOutline = exports.webSystemScaleOutline = exports.webSystemProgressCircleOutline = exports.webSystemOption = exports.webSystemListOutline = exports.webSystemLinkOutline = exports.webSystemLinkHorizontalOutline = exports.webSystemHierarchyOutline = exports.webSystemFormOutline = exports.webSystemFaviconOutline = exports.webSystemExternalOutline = exports.webSystemExitOutline = exports.webSystemEnterOutline = exports.webSystemDashboardOutline = undefined;
exports.webSystemDashboardFilled = exports.webSystemCommand = exports.webSystemCode = exports.webSystemCarouselOutline = exports.userPersonOutline = exports.userPersonFilled = exports.userPersonAddOutline = exports.userPersonAddFilled = exports.userPeopleOutline = exports.userPeopleFilled = exports.systemSystemTerminalFilled = exports.symbolsZoomOutOutline = exports.symbolsZoomOutFilled = exports.symbolsZoomInOutline = exports.symbolsZoomInFilled = exports.symbolsWifiOutline = exports.symbolsWidgetOutline = exports.symbolsWidgetFilled = exports.symbolsStarOutline = exports.symbolsStarFilled = exports.symbolsSquare = exports.symbolsRectangle = exports.symbolsRadioButtonSelectedOutline = exports.symbolsRadioButtonOutline = exports.symbolsPlusFilled = exports.symbolsPieChartOutline = exports.symbolsPieChartFilled = exports.symbolsPercentageOutline = exports.symbolsPaperPlaneTiltOutline = exports.symbolsPaperPlaneTiltFilled = exports.symbolsPaperPlaneRightOutline = exports.symbolsPaperPlaneRightFilled = exports.symbolsMinusOutline = exports.symbolsLikeOutline = exports.symbolsLikeFilled = exports.symbolsLightOutline = exports.symbolsLightFilled = exports.symbolsHeartOutline = exports.symbolsHeartFilled = exports.symbolsEyeOutline = exports.symbolsEyeOffOutline = exports.symbolsEyeOffFilled = exports.symbolsEyeFilled = exports.symbolsEditOutline = exports.symbolsDropOutline = exports.symbolsDropFilled = exports.symbolsDarkOutline = exports.symbolsDarkFilled = exports.symbolsCopyOutline = exports.symbolsCopyFilled = exports.symbolsCloudOutline = exports.symbolsCloudFilled = exports.symbolsCloseOutline = exports.symbolsCircle = exports.symbolsCirclePlusOutline = exports.symbolsCirclePlusFilled = exports.symbolsCircleInfoOutline = exports.symbolsCircleInfoFilled = exports.symbolsCircleHelpOutline = exports.symbolsCircleHelpFilled = exports.symbolsCircleCloseOutline = exports.symbolsCircleCloseFilled = exports.symbolsCircleCheckOutline = exports.symbolsCircleCheckFilled = exports.symbolsCircleAlertOutline = exports.symbolsCircleAlertFilled = exports.symbolsCheckboxSelectedOutline = exports.symbolsCheckboxSelectedFilled = exports.symbolsCheckboxOutline = exports.symbolsCheckboxIndeterminatedOutline = exports.symbolsCheckboxIndeterminatedFilled = exports.symbolsCheckOutline = exports.symbolsBroadcastOutline = exports.symbolsBookmarkOutline = exports.symbolsBookmarkFilled = exports.symbolsBarsRightOutline = exports.symbolsBarsOutline = exports.symbolsBarsLeftOutline = exports.symbolsBarChartOutline = exports.symbolsAlertOutline = exports.symbolsAlertFilled = exports.symbolsAdjustOutline = exports.shopTicketOutline = exports.shopTicketFilled = exports.shopTagOutline = exports.shopTagFilled = exports.shopBarcodeOutline = exports.shopAddToCartOutline = exports.shopAddToCartFilled = exports.servicesVps = exports.servicesSsl = exports.servicesSmtp = exports.servicesRevenda = exports.servicesRegistroDeDominio = exports.servicesHospedagemWordpress = exports.servicesHospedagemDedicada = exports.servicesHospedagemDeSites = exports.servicesGoogleWorkspace = exports.servicesEmailMarketing = exports.servicesEmailLocaweb = undefined;
exports.servicesEmailGo = exports.servicesEmailExchange = exports.servicesCriadorDeSites = exports.servicesCloudServerPro = exports.servicesClicLead = exports.serverUploadOutline = exports.serverFtpOutline = exports.serverFtpFilled = exports.serverDownloadOutline = exports.serverDnsOutline = exports.serverDnsFilled = exports.serverDatabaseOutline = exports.serverDatabaseFilled = exports.serverCloudOutline = exports.serverCloudFilled = exports.securityShieldOutline = exports.securityShieldLockOutline = exports.securityShieldLockOpenOutline = exports.securityShieldLockOpenFilled = exports.securityShieldLockFilled = exports.securityShieldFilled = exports.securityShieldAlertOutline = exports.securityShieldAlertFilled = exports.securityFirewallOutline = exports.placesStoreOutline = exports.placesHomeOutline = exports.placesHomeFilled = exports.objectsWandOutline = exports.objectsVideocameraOutline = exports.objectsVideocameraFilled = exports.objectsTrashOutline = exports.objectsTrashFilled = exports.objectsToolOutline = exports.objectsToolFilled = exports.objectsStopwatchOutline = exports.objectsStopwatchFilled = exports.objectsSignOutline = exports.objectsSignFilled = exports.objectsPuzzleOutline = exports.objectsPuzzleFilled = exports.objectsPrinterOutline = exports.objectsPrinterFilled = exports.objectsPickerOutline = exports.objectsPhoneOutline = exports.objectsPhoneFilled = exports.objectsPencilOutline = exports.objectsPencilFilled = exports.objectsPaperclipOutline = exports.objectsPaintBucketOutline = exports.objectsPaintBucketFilled = exports.objectsMicrophoneOutline = exports.objectsMicrophoneFilled = exports.objectsMegaphoneOutline = exports.objectsMailOutline = exports.objectsMailOpenOutline = exports.objectsMailOpenFilled = exports.objectsMailFilled = exports.objectsMagnifyOutline = exports.objectsLockOutline = exports.objectsLockOpenOutline = exports.objectsLockOpenFilled = exports.objectsLockFilled = exports.objectsLampOutline = exports.objectsLampOnOutline = exports.objectsLampOnFilled = exports.objectsLampFilled = exports.objectsKeyOutline = exports.objectsHeadphoneOutline = exports.objectsHeadphoneFilled = exports.objectsGiftOutline = exports.objectsGearOutline = exports.objectsGearFilled = exports.objectsFunnelOutline = exports.objectsFunnelFilled = exports.objectsFolderOutline = exports.objectsFolderFilled = exports.objectsFloppyDiskOutline = exports.objectsFloppyDiskFilled = exports.objectsEraserOutline = exports.objectsCompassOutline = exports.objectsClockOutline = exports.objectsClockFilled = exports.objectsCdOutline = exports.objectsCdFilled = exports.objectsCameraOutline = exports.objectsCameraFilled = exports.objectsCalendarOutline = exports.objectsCalendarFilled = exports.objectsCalculatorOutline = exports.objectsCalculatorFilled = exports.objectsBoxOutline = exports.objectsBoxFilled = exports.objectsBellOutline = exports.objectsBellOffOutline = exports.objectsBellOffFilled = exports.objectsBellFilled = exports.objectsBalanceOutline = exports.objectsBalanceFilled = exports.mediaVolumeOnOutline = exports.mediaVolumeOnFilled = undefined;
exports.mediaVolumeOffOutline = exports.mediaVolumeOffFilled = exports.mediaPlayOutline = exports.mediaPlayFilled = exports.mediaPauseOutline = exports.mediaPauseFilled = exports.mediaImageOutline = exports.mediaImageFilled = exports.mediaImageExpandedOutline = exports.mediaImageExpandedFilled = exports.localizationPinOutline = exports.localizationPinFilled = exports.localizationGlobePlusOutline = exports.localizationGlobePlusFilled = exports.localizationGlobePinnedOutline = exports.localizationGlobePinnedFilled = exports.localizationGlobeOutline = exports.localizationGlobeFilled = exports.hardwareSsdOutline = exports.hardwareSsdFilled = exports.hardwareMemoryOutline = exports.hardwareMemoryFilled = exports.hardwareHddOutline = exports.hardwareHddFilled = exports.hardwareCpuOutline = exports.hardwareCpuFilled = exports.financeDollarSignOutline = exports.financeDollarSignOffOutline = exports.financeCreditCardsOutline = exports.financeCreditCardsFilled = exports.financeCreditCardOutline = exports.financeCreditCardFilled = exports.financeCircleDollarSignOutline = exports.financeCircleDollarSignFilled = exports.financeCashOutline = exports.financeCashFilled = exports.filesTextFileOutline = exports.filesTextFileFilled = exports.filesStatementOutline = exports.filesStatementFilled = exports.filesSearchOutline = exports.filesSearchFilled = exports.filesReportsOutline = exports.filesPlusOutline = exports.filesPlusFilled = exports.filesMinusOutline = exports.filesMinusFilled = exports.filesHistoryOutline = exports.filesHistoryFilled = exports.filesFile = exports.filesCloseOutline = exports.filesCloseFilled = exports.filesCheckOutline = exports.filesCheckFilled = exports.emoteSadOutline = exports.emoteSadFilled = exports.emoteHappyOutline = exports.emoteHappyFilled = exports.editorTitleOutline = exports.editorTextItalicOutline = exports.editorTextBoldOutline = exports.editorTextAlignRight = exports.editorTextAlignLeft = exports.editorTextAlignJustify = exports.editorTextAlignCenter = exports.editorTableOutline = exports.dotsThreeVertical = exports.dotsThreeHorizontal = exports.dotsSixVertical = exports.dotsSixHorizontal = exports.dotsOne = exports.dotsNine = exports.devicesTabletOutline = exports.devicesSmartphoneOutline = exports.devicesScreenOutline = exports.communicationQuoteOutline = exports.communicationQuoteFilled = exports.communicationHelpChatOutline = exports.communicationHelpChatFilled = exports.communicationChatOutline = exports.communicationChatOffOutline = exports.communicationChatOffFilled = exports.communicationChatFilled = exports.communicationChatAlertOutline = exports.communicationChatAlertFilled = exports.brandZenphotoFilled = exports.brandYapay = exports.brandWordpressFilled = exports.brandWoocommerceFilled = exports.brandWindowsFilled = exports.brandWhatsappFilled = exports.brandVisaFilled = exports.brandVindi = exports.brandUbuntuFilled = exports.brandTray = exports.brandThunderbirdFilled = exports.brandTelegramFilled = exports.brandSugarcrmFilled = exports.brandSourceforgeFilled = exports.brandSocialminer = undefined;
exports.brandSamuraiExperts = exports.brandRedisFilled = exports.brandPostgresqlFilled = exports.brandPixFilled = exports.brandPhpmyadminFilled = exports.brandPhpFilled = exports.brandOutlookOutline = exports.brandOpensuseFilled = exports.brandNodejsFilled = exports.brandNginxFilled = exports.brandNextios = exports.brandMysqlOutline = exports.brandMysqlFilled = exports.brandMongodbFilled = exports.brandMicrosoftsqlserverSymbolFilled = exports.brandMicrosoftFilled = exports.brandMelhorenvio = exports.brandMastercardSymbolFilled = exports.brandMastercardFilled = exports.brandMariadbFilled = exports.brandLocawebFilled = exports.brandLinuxFilled = exports.brandLampFilled = exports.brandJoomlaFilled = exports.brandInstagramFilled = exports.brandIderis = exports.brandGoogleAnalyticsFilled = exports.brandGitlabFilled = exports.brandGithubFilled = exports.brandGitFilled = exports.brandFirebaseFilled = exports.brandFilezillaFilled = exports.brandFedoraFilled = exports.brandFacebookFilled = exports.brandEtus = exports.brandEloFilled = exports.brandDrupalFilled = exports.brandDooca = exports.brandDinersClub = exports.brandDesk360 = exports.brandDeliveryDireto = exports.brandDebianFilled = exports.brandCronospainel = exports.brandCredisfera = exports.brandCplug = exports.brandCentosFilled = exports.brandBitbucketFilled = exports.brandAppleFilled = exports.brandAndroidFilled = exports.brandAmericanExpress = exports.brandAllin = exports.arrowsVerticalOutline = exports.arrowsUpOutline = exports.arrowsShrinkOutline = exports.arrowsRightOutline = exports.arrowsOutCardinalOutline = exports.arrowsLeftOutline = exports.arrowsLeftDown = exports.arrowsLeftAndRightOutline = exports.arrowsHorizontalOutline = exports.arrowsFatUpOutline = exports.arrowsFatUpFilled = exports.arrowsFatRightOutline = exports.arrowsFatRightFilled = exports.arrowsFatLineUpOutline = exports.arrowsFatLineUpFilled = exports.arrowsFatLineRightOutline = exports.arrowsFatLineRightFilled = exports.arrowsFatLineLeftOutline = exports.arrowsFatLineLeftFilled = exports.arrowsFatLineDownOutline = exports.arrowsFatLineDownFilled = exports.arrowsFatLeftOutline = exports.arrowsFatLeftFilled = exports.arrowsFatDownOutline = exports.arrowsFatDownFilled = exports.arrowsDownOutline = exports.arrowsCycleCheckOutline = exports.arrowsCounterClockwise = exports.arrowsClockwise = exports.arrowsCircleArrowUpOutline = exports.arrowsCircleArrowUpFilled = exports.arrowsCircleArrowRightOutline = exports.arrowsCircleArrowRightFilled = exports.arrowsCircleArrowLeftOutline = exports.arrowsCircleArrowLeftFilled = exports.arrowsCircleArrowDownOutline = exports.arrowsCircleArrowDownFilled = exports.arrowsChevronUpOutline = exports.arrowsChevronUpFilled = exports.arrowsChevronUpAndDownOutline = exports.arrowsChevronRightOutline = exports.arrowsChevronRightFilled = exports.arrowsChevronLeftOutline = exports.arrowsChevronLeftFilled = exports.arrowsChevronDownOutline = exports.arrowsChevronDownFilled = exports.arrowsBendUpRight = exports.arrowsBendUpLeft = exports.arrowsArrowsOutOutline = undefined;
exports.registerIcon = registerIcon;

var _ArrowsArrowsOutOutline = require('./icons/ArrowsArrowsOutOutline.vue');

var _ArrowsArrowsOutOutline2 = _interopRequireDefault(_ArrowsArrowsOutOutline);

var _ArrowsBendUpLeft = require('./icons/ArrowsBendUpLeft.vue');

var _ArrowsBendUpLeft2 = _interopRequireDefault(_ArrowsBendUpLeft);

var _ArrowsBendUpRight = require('./icons/ArrowsBendUpRight.vue');

var _ArrowsBendUpRight2 = _interopRequireDefault(_ArrowsBendUpRight);

var _ArrowsChevronDownFilled = require('./icons/ArrowsChevronDownFilled.vue');

var _ArrowsChevronDownFilled2 = _interopRequireDefault(_ArrowsChevronDownFilled);

var _ArrowsChevronDownOutline = require('./icons/ArrowsChevronDownOutline.vue');

var _ArrowsChevronDownOutline2 = _interopRequireDefault(_ArrowsChevronDownOutline);

var _ArrowsChevronLeftFilled = require('./icons/ArrowsChevronLeftFilled.vue');

var _ArrowsChevronLeftFilled2 = _interopRequireDefault(_ArrowsChevronLeftFilled);

var _ArrowsChevronLeftOutline = require('./icons/ArrowsChevronLeftOutline.vue');

var _ArrowsChevronLeftOutline2 = _interopRequireDefault(_ArrowsChevronLeftOutline);

var _ArrowsChevronRightFilled = require('./icons/ArrowsChevronRightFilled.vue');

var _ArrowsChevronRightFilled2 = _interopRequireDefault(_ArrowsChevronRightFilled);

var _ArrowsChevronRightOutline = require('./icons/ArrowsChevronRightOutline.vue');

var _ArrowsChevronRightOutline2 = _interopRequireDefault(_ArrowsChevronRightOutline);

var _ArrowsChevronUpAndDownOutline = require('./icons/ArrowsChevronUpAndDownOutline.vue');

var _ArrowsChevronUpAndDownOutline2 = _interopRequireDefault(_ArrowsChevronUpAndDownOutline);

var _ArrowsChevronUpFilled = require('./icons/ArrowsChevronUpFilled.vue');

var _ArrowsChevronUpFilled2 = _interopRequireDefault(_ArrowsChevronUpFilled);

var _ArrowsChevronUpOutline = require('./icons/ArrowsChevronUpOutline.vue');

var _ArrowsChevronUpOutline2 = _interopRequireDefault(_ArrowsChevronUpOutline);

var _ArrowsCircleArrowDownFilled = require('./icons/ArrowsCircleArrowDownFilled.vue');

var _ArrowsCircleArrowDownFilled2 = _interopRequireDefault(_ArrowsCircleArrowDownFilled);

var _ArrowsCircleArrowDownOutline = require('./icons/ArrowsCircleArrowDownOutline.vue');

var _ArrowsCircleArrowDownOutline2 = _interopRequireDefault(_ArrowsCircleArrowDownOutline);

var _ArrowsCircleArrowLeftFilled = require('./icons/ArrowsCircleArrowLeftFilled.vue');

var _ArrowsCircleArrowLeftFilled2 = _interopRequireDefault(_ArrowsCircleArrowLeftFilled);

var _ArrowsCircleArrowLeftOutline = require('./icons/ArrowsCircleArrowLeftOutline.vue');

var _ArrowsCircleArrowLeftOutline2 = _interopRequireDefault(_ArrowsCircleArrowLeftOutline);

var _ArrowsCircleArrowRightFilled = require('./icons/ArrowsCircleArrowRightFilled.vue');

var _ArrowsCircleArrowRightFilled2 = _interopRequireDefault(_ArrowsCircleArrowRightFilled);

var _ArrowsCircleArrowRightOutline = require('./icons/ArrowsCircleArrowRightOutline.vue');

var _ArrowsCircleArrowRightOutline2 = _interopRequireDefault(_ArrowsCircleArrowRightOutline);

var _ArrowsCircleArrowUpFilled = require('./icons/ArrowsCircleArrowUpFilled.vue');

var _ArrowsCircleArrowUpFilled2 = _interopRequireDefault(_ArrowsCircleArrowUpFilled);

var _ArrowsCircleArrowUpOutline = require('./icons/ArrowsCircleArrowUpOutline.vue');

var _ArrowsCircleArrowUpOutline2 = _interopRequireDefault(_ArrowsCircleArrowUpOutline);

var _ArrowsClockwise = require('./icons/ArrowsClockwise.vue');

var _ArrowsClockwise2 = _interopRequireDefault(_ArrowsClockwise);

var _ArrowsCounterClockwise = require('./icons/ArrowsCounterClockwise.vue');

var _ArrowsCounterClockwise2 = _interopRequireDefault(_ArrowsCounterClockwise);

var _ArrowsCycleCheckOutline = require('./icons/ArrowsCycleCheckOutline.vue');

var _ArrowsCycleCheckOutline2 = _interopRequireDefault(_ArrowsCycleCheckOutline);

var _ArrowsDownOutline = require('./icons/ArrowsDownOutline.vue');

var _ArrowsDownOutline2 = _interopRequireDefault(_ArrowsDownOutline);

var _ArrowsFatDownFilled = require('./icons/ArrowsFatDownFilled.vue');

var _ArrowsFatDownFilled2 = _interopRequireDefault(_ArrowsFatDownFilled);

var _ArrowsFatDownOutline = require('./icons/ArrowsFatDownOutline.vue');

var _ArrowsFatDownOutline2 = _interopRequireDefault(_ArrowsFatDownOutline);

var _ArrowsFatLeftFilled = require('./icons/ArrowsFatLeftFilled.vue');

var _ArrowsFatLeftFilled2 = _interopRequireDefault(_ArrowsFatLeftFilled);

var _ArrowsFatLeftOutline = require('./icons/ArrowsFatLeftOutline.vue');

var _ArrowsFatLeftOutline2 = _interopRequireDefault(_ArrowsFatLeftOutline);

var _ArrowsFatLineDownFilled = require('./icons/ArrowsFatLineDownFilled.vue');

var _ArrowsFatLineDownFilled2 = _interopRequireDefault(_ArrowsFatLineDownFilled);

var _ArrowsFatLineDownOutline = require('./icons/ArrowsFatLineDownOutline.vue');

var _ArrowsFatLineDownOutline2 = _interopRequireDefault(_ArrowsFatLineDownOutline);

var _ArrowsFatLineLeftFilled = require('./icons/ArrowsFatLineLeftFilled.vue');

var _ArrowsFatLineLeftFilled2 = _interopRequireDefault(_ArrowsFatLineLeftFilled);

var _ArrowsFatLineLeftOutline = require('./icons/ArrowsFatLineLeftOutline.vue');

var _ArrowsFatLineLeftOutline2 = _interopRequireDefault(_ArrowsFatLineLeftOutline);

var _ArrowsFatLineRightFilled = require('./icons/ArrowsFatLineRightFilled.vue');

var _ArrowsFatLineRightFilled2 = _interopRequireDefault(_ArrowsFatLineRightFilled);

var _ArrowsFatLineRightOutline = require('./icons/ArrowsFatLineRightOutline.vue');

var _ArrowsFatLineRightOutline2 = _interopRequireDefault(_ArrowsFatLineRightOutline);

var _ArrowsFatLineUpFilled = require('./icons/ArrowsFatLineUpFilled.vue');

var _ArrowsFatLineUpFilled2 = _interopRequireDefault(_ArrowsFatLineUpFilled);

var _ArrowsFatLineUpOutline = require('./icons/ArrowsFatLineUpOutline.vue');

var _ArrowsFatLineUpOutline2 = _interopRequireDefault(_ArrowsFatLineUpOutline);

var _ArrowsFatRightFilled = require('./icons/ArrowsFatRightFilled.vue');

var _ArrowsFatRightFilled2 = _interopRequireDefault(_ArrowsFatRightFilled);

var _ArrowsFatRightOutline = require('./icons/ArrowsFatRightOutline.vue');

var _ArrowsFatRightOutline2 = _interopRequireDefault(_ArrowsFatRightOutline);

var _ArrowsFatUpFilled = require('./icons/ArrowsFatUpFilled.vue');

var _ArrowsFatUpFilled2 = _interopRequireDefault(_ArrowsFatUpFilled);

var _ArrowsFatUpOutline = require('./icons/ArrowsFatUpOutline.vue');

var _ArrowsFatUpOutline2 = _interopRequireDefault(_ArrowsFatUpOutline);

var _ArrowsHorizontalOutline = require('./icons/ArrowsHorizontalOutline.vue');

var _ArrowsHorizontalOutline2 = _interopRequireDefault(_ArrowsHorizontalOutline);

var _ArrowsLeftAndRightOutline = require('./icons/ArrowsLeftAndRightOutline.vue');

var _ArrowsLeftAndRightOutline2 = _interopRequireDefault(_ArrowsLeftAndRightOutline);

var _ArrowsLeftDown = require('./icons/ArrowsLeftDown.vue');

var _ArrowsLeftDown2 = _interopRequireDefault(_ArrowsLeftDown);

var _ArrowsLeftOutline = require('./icons/ArrowsLeftOutline.vue');

var _ArrowsLeftOutline2 = _interopRequireDefault(_ArrowsLeftOutline);

var _ArrowsOutCardinalOutline = require('./icons/ArrowsOutCardinalOutline.vue');

var _ArrowsOutCardinalOutline2 = _interopRequireDefault(_ArrowsOutCardinalOutline);

var _ArrowsRightOutline = require('./icons/ArrowsRightOutline.vue');

var _ArrowsRightOutline2 = _interopRequireDefault(_ArrowsRightOutline);

var _ArrowsShrinkOutline = require('./icons/ArrowsShrinkOutline.vue');

var _ArrowsShrinkOutline2 = _interopRequireDefault(_ArrowsShrinkOutline);

var _ArrowsUpOutline = require('./icons/ArrowsUpOutline.vue');

var _ArrowsUpOutline2 = _interopRequireDefault(_ArrowsUpOutline);

var _ArrowsVerticalOutline = require('./icons/ArrowsVerticalOutline.vue');

var _ArrowsVerticalOutline2 = _interopRequireDefault(_ArrowsVerticalOutline);

var _BrandAllin = require('./icons/BrandAllin.vue');

var _BrandAllin2 = _interopRequireDefault(_BrandAllin);

var _BrandAmericanExpress = require('./icons/BrandAmericanExpress.vue');

var _BrandAmericanExpress2 = _interopRequireDefault(_BrandAmericanExpress);

var _BrandAndroidFilled = require('./icons/BrandAndroidFilled.vue');

var _BrandAndroidFilled2 = _interopRequireDefault(_BrandAndroidFilled);

var _BrandAppleFilled = require('./icons/BrandAppleFilled.vue');

var _BrandAppleFilled2 = _interopRequireDefault(_BrandAppleFilled);

var _BrandBitbucketFilled = require('./icons/BrandBitbucketFilled.vue');

var _BrandBitbucketFilled2 = _interopRequireDefault(_BrandBitbucketFilled);

var _BrandCentosFilled = require('./icons/BrandCentosFilled.vue');

var _BrandCentosFilled2 = _interopRequireDefault(_BrandCentosFilled);

var _BrandCplug = require('./icons/BrandCplug.vue');

var _BrandCplug2 = _interopRequireDefault(_BrandCplug);

var _BrandCredisfera = require('./icons/BrandCredisfera.vue');

var _BrandCredisfera2 = _interopRequireDefault(_BrandCredisfera);

var _BrandCronospainel = require('./icons/BrandCronospainel.vue');

var _BrandCronospainel2 = _interopRequireDefault(_BrandCronospainel);

var _BrandDebianFilled = require('./icons/BrandDebianFilled.vue');

var _BrandDebianFilled2 = _interopRequireDefault(_BrandDebianFilled);

var _BrandDeliveryDireto = require('./icons/BrandDeliveryDireto.vue');

var _BrandDeliveryDireto2 = _interopRequireDefault(_BrandDeliveryDireto);

var _BrandDesk = require('./icons/BrandDesk360.vue');

var _BrandDesk2 = _interopRequireDefault(_BrandDesk);

var _BrandDinersClub = require('./icons/BrandDinersClub.vue');

var _BrandDinersClub2 = _interopRequireDefault(_BrandDinersClub);

var _BrandDooca = require('./icons/BrandDooca.vue');

var _BrandDooca2 = _interopRequireDefault(_BrandDooca);

var _BrandDrupalFilled = require('./icons/BrandDrupalFilled.vue');

var _BrandDrupalFilled2 = _interopRequireDefault(_BrandDrupalFilled);

var _BrandEloFilled = require('./icons/BrandEloFilled.vue');

var _BrandEloFilled2 = _interopRequireDefault(_BrandEloFilled);

var _BrandEtus = require('./icons/BrandEtus.vue');

var _BrandEtus2 = _interopRequireDefault(_BrandEtus);

var _BrandFacebookFilled = require('./icons/BrandFacebookFilled.vue');

var _BrandFacebookFilled2 = _interopRequireDefault(_BrandFacebookFilled);

var _BrandFedoraFilled = require('./icons/BrandFedoraFilled.vue');

var _BrandFedoraFilled2 = _interopRequireDefault(_BrandFedoraFilled);

var _BrandFilezillaFilled = require('./icons/BrandFilezillaFilled.vue');

var _BrandFilezillaFilled2 = _interopRequireDefault(_BrandFilezillaFilled);

var _BrandFirebaseFilled = require('./icons/BrandFirebaseFilled.vue');

var _BrandFirebaseFilled2 = _interopRequireDefault(_BrandFirebaseFilled);

var _BrandGitFilled = require('./icons/BrandGitFilled.vue');

var _BrandGitFilled2 = _interopRequireDefault(_BrandGitFilled);

var _BrandGithubFilled = require('./icons/BrandGithubFilled.vue');

var _BrandGithubFilled2 = _interopRequireDefault(_BrandGithubFilled);

var _BrandGitlabFilled = require('./icons/BrandGitlabFilled.vue');

var _BrandGitlabFilled2 = _interopRequireDefault(_BrandGitlabFilled);

var _BrandGoogleAnalyticsFilled = require('./icons/BrandGoogleAnalyticsFilled.vue');

var _BrandGoogleAnalyticsFilled2 = _interopRequireDefault(_BrandGoogleAnalyticsFilled);

var _BrandIderis = require('./icons/BrandIderis.vue');

var _BrandIderis2 = _interopRequireDefault(_BrandIderis);

var _BrandInstagramFilled = require('./icons/BrandInstagramFilled.vue');

var _BrandInstagramFilled2 = _interopRequireDefault(_BrandInstagramFilled);

var _BrandJoomlaFilled = require('./icons/BrandJoomlaFilled.vue');

var _BrandJoomlaFilled2 = _interopRequireDefault(_BrandJoomlaFilled);

var _BrandLampFilled = require('./icons/BrandLampFilled.vue');

var _BrandLampFilled2 = _interopRequireDefault(_BrandLampFilled);

var _BrandLinuxFilled = require('./icons/BrandLinuxFilled.vue');

var _BrandLinuxFilled2 = _interopRequireDefault(_BrandLinuxFilled);

var _BrandLocawebFilled = require('./icons/BrandLocawebFilled.vue');

var _BrandLocawebFilled2 = _interopRequireDefault(_BrandLocawebFilled);

var _BrandMariadbFilled = require('./icons/BrandMariadbFilled.vue');

var _BrandMariadbFilled2 = _interopRequireDefault(_BrandMariadbFilled);

var _BrandMastercardFilled = require('./icons/BrandMastercardFilled.vue');

var _BrandMastercardFilled2 = _interopRequireDefault(_BrandMastercardFilled);

var _BrandMastercardSymbolFilled = require('./icons/BrandMastercardSymbolFilled.vue');

var _BrandMastercardSymbolFilled2 = _interopRequireDefault(_BrandMastercardSymbolFilled);

var _BrandMelhorenvio = require('./icons/BrandMelhorenvio.vue');

var _BrandMelhorenvio2 = _interopRequireDefault(_BrandMelhorenvio);

var _BrandMicrosoftFilled = require('./icons/BrandMicrosoftFilled.vue');

var _BrandMicrosoftFilled2 = _interopRequireDefault(_BrandMicrosoftFilled);

var _BrandMicrosoftsqlserverSymbolFilled = require('./icons/BrandMicrosoftsqlserverSymbolFilled.vue');

var _BrandMicrosoftsqlserverSymbolFilled2 = _interopRequireDefault(_BrandMicrosoftsqlserverSymbolFilled);

var _BrandMongodbFilled = require('./icons/BrandMongodbFilled.vue');

var _BrandMongodbFilled2 = _interopRequireDefault(_BrandMongodbFilled);

var _BrandMysqlFilled = require('./icons/BrandMysqlFilled.vue');

var _BrandMysqlFilled2 = _interopRequireDefault(_BrandMysqlFilled);

var _BrandMysqlOutline = require('./icons/BrandMysqlOutline.vue');

var _BrandMysqlOutline2 = _interopRequireDefault(_BrandMysqlOutline);

var _BrandNextios = require('./icons/BrandNextios.vue');

var _BrandNextios2 = _interopRequireDefault(_BrandNextios);

var _BrandNginxFilled = require('./icons/BrandNginxFilled.vue');

var _BrandNginxFilled2 = _interopRequireDefault(_BrandNginxFilled);

var _BrandNodejsFilled = require('./icons/BrandNodejsFilled.vue');

var _BrandNodejsFilled2 = _interopRequireDefault(_BrandNodejsFilled);

var _BrandOpensuseFilled = require('./icons/BrandOpensuseFilled.vue');

var _BrandOpensuseFilled2 = _interopRequireDefault(_BrandOpensuseFilled);

var _BrandOutlookOutline = require('./icons/BrandOutlookOutline.vue');

var _BrandOutlookOutline2 = _interopRequireDefault(_BrandOutlookOutline);

var _BrandPhpFilled = require('./icons/BrandPhpFilled.vue');

var _BrandPhpFilled2 = _interopRequireDefault(_BrandPhpFilled);

var _BrandPhpmyadminFilled = require('./icons/BrandPhpmyadminFilled.vue');

var _BrandPhpmyadminFilled2 = _interopRequireDefault(_BrandPhpmyadminFilled);

var _BrandPixFilled = require('./icons/BrandPixFilled.vue');

var _BrandPixFilled2 = _interopRequireDefault(_BrandPixFilled);

var _BrandPostgresqlFilled = require('./icons/BrandPostgresqlFilled.vue');

var _BrandPostgresqlFilled2 = _interopRequireDefault(_BrandPostgresqlFilled);

var _BrandRedisFilled = require('./icons/BrandRedisFilled.vue');

var _BrandRedisFilled2 = _interopRequireDefault(_BrandRedisFilled);

var _BrandSamuraiExperts = require('./icons/BrandSamuraiExperts.vue');

var _BrandSamuraiExperts2 = _interopRequireDefault(_BrandSamuraiExperts);

var _BrandSocialminer = require('./icons/BrandSocialminer.vue');

var _BrandSocialminer2 = _interopRequireDefault(_BrandSocialminer);

var _BrandSourceforgeFilled = require('./icons/BrandSourceforgeFilled.vue');

var _BrandSourceforgeFilled2 = _interopRequireDefault(_BrandSourceforgeFilled);

var _BrandSugarcrmFilled = require('./icons/BrandSugarcrmFilled.vue');

var _BrandSugarcrmFilled2 = _interopRequireDefault(_BrandSugarcrmFilled);

var _BrandTelegramFilled = require('./icons/BrandTelegramFilled.vue');

var _BrandTelegramFilled2 = _interopRequireDefault(_BrandTelegramFilled);

var _BrandThunderbirdFilled = require('./icons/BrandThunderbirdFilled.vue');

var _BrandThunderbirdFilled2 = _interopRequireDefault(_BrandThunderbirdFilled);

var _BrandTray = require('./icons/BrandTray.vue');

var _BrandTray2 = _interopRequireDefault(_BrandTray);

var _BrandUbuntuFilled = require('./icons/BrandUbuntuFilled.vue');

var _BrandUbuntuFilled2 = _interopRequireDefault(_BrandUbuntuFilled);

var _BrandVindi = require('./icons/BrandVindi.vue');

var _BrandVindi2 = _interopRequireDefault(_BrandVindi);

var _BrandVisaFilled = require('./icons/BrandVisaFilled.vue');

var _BrandVisaFilled2 = _interopRequireDefault(_BrandVisaFilled);

var _BrandWhatsappFilled = require('./icons/BrandWhatsappFilled.vue');

var _BrandWhatsappFilled2 = _interopRequireDefault(_BrandWhatsappFilled);

var _BrandWindowsFilled = require('./icons/BrandWindowsFilled.vue');

var _BrandWindowsFilled2 = _interopRequireDefault(_BrandWindowsFilled);

var _BrandWoocommerceFilled = require('./icons/BrandWoocommerceFilled.vue');

var _BrandWoocommerceFilled2 = _interopRequireDefault(_BrandWoocommerceFilled);

var _BrandWordpressFilled = require('./icons/BrandWordpressFilled.vue');

var _BrandWordpressFilled2 = _interopRequireDefault(_BrandWordpressFilled);

var _BrandYapay = require('./icons/BrandYapay.vue');

var _BrandYapay2 = _interopRequireDefault(_BrandYapay);

var _BrandZenphotoFilled = require('./icons/BrandZenphotoFilled.vue');

var _BrandZenphotoFilled2 = _interopRequireDefault(_BrandZenphotoFilled);

var _CommunicationChatAlertFilled = require('./icons/CommunicationChatAlertFilled.vue');

var _CommunicationChatAlertFilled2 = _interopRequireDefault(_CommunicationChatAlertFilled);

var _CommunicationChatAlertOutline = require('./icons/CommunicationChatAlertOutline.vue');

var _CommunicationChatAlertOutline2 = _interopRequireDefault(_CommunicationChatAlertOutline);

var _CommunicationChatFilled = require('./icons/CommunicationChatFilled.vue');

var _CommunicationChatFilled2 = _interopRequireDefault(_CommunicationChatFilled);

var _CommunicationChatOffFilled = require('./icons/CommunicationChatOffFilled.vue');

var _CommunicationChatOffFilled2 = _interopRequireDefault(_CommunicationChatOffFilled);

var _CommunicationChatOffOutline = require('./icons/CommunicationChatOffOutline.vue');

var _CommunicationChatOffOutline2 = _interopRequireDefault(_CommunicationChatOffOutline);

var _CommunicationChatOutline = require('./icons/CommunicationChatOutline.vue');

var _CommunicationChatOutline2 = _interopRequireDefault(_CommunicationChatOutline);

var _CommunicationHelpChatFilled = require('./icons/CommunicationHelpChatFilled.vue');

var _CommunicationHelpChatFilled2 = _interopRequireDefault(_CommunicationHelpChatFilled);

var _CommunicationHelpChatOutline = require('./icons/CommunicationHelpChatOutline.vue');

var _CommunicationHelpChatOutline2 = _interopRequireDefault(_CommunicationHelpChatOutline);

var _CommunicationQuoteFilled = require('./icons/CommunicationQuoteFilled.vue');

var _CommunicationQuoteFilled2 = _interopRequireDefault(_CommunicationQuoteFilled);

var _CommunicationQuoteOutline = require('./icons/CommunicationQuoteOutline.vue');

var _CommunicationQuoteOutline2 = _interopRequireDefault(_CommunicationQuoteOutline);

var _DevicesScreenOutline = require('./icons/DevicesScreenOutline.vue');

var _DevicesScreenOutline2 = _interopRequireDefault(_DevicesScreenOutline);

var _DevicesSmartphoneOutline = require('./icons/DevicesSmartphoneOutline.vue');

var _DevicesSmartphoneOutline2 = _interopRequireDefault(_DevicesSmartphoneOutline);

var _DevicesTabletOutline = require('./icons/DevicesTabletOutline.vue');

var _DevicesTabletOutline2 = _interopRequireDefault(_DevicesTabletOutline);

var _DotsNine = require('./icons/DotsNine.vue');

var _DotsNine2 = _interopRequireDefault(_DotsNine);

var _DotsOne = require('./icons/DotsOne.vue');

var _DotsOne2 = _interopRequireDefault(_DotsOne);

var _DotsSixHorizontal = require('./icons/DotsSixHorizontal.vue');

var _DotsSixHorizontal2 = _interopRequireDefault(_DotsSixHorizontal);

var _DotsSixVertical = require('./icons/DotsSixVertical.vue');

var _DotsSixVertical2 = _interopRequireDefault(_DotsSixVertical);

var _DotsThreeHorizontal = require('./icons/DotsThreeHorizontal.vue');

var _DotsThreeHorizontal2 = _interopRequireDefault(_DotsThreeHorizontal);

var _DotsThreeVertical = require('./icons/DotsThreeVertical.vue');

var _DotsThreeVertical2 = _interopRequireDefault(_DotsThreeVertical);

var _EditorTableOutline = require('./icons/EditorTableOutline.vue');

var _EditorTableOutline2 = _interopRequireDefault(_EditorTableOutline);

var _EditorTextAlignCenter = require('./icons/EditorTextAlignCenter.vue');

var _EditorTextAlignCenter2 = _interopRequireDefault(_EditorTextAlignCenter);

var _EditorTextAlignJustify = require('./icons/EditorTextAlignJustify.vue');

var _EditorTextAlignJustify2 = _interopRequireDefault(_EditorTextAlignJustify);

var _EditorTextAlignLeft = require('./icons/EditorTextAlignLeft.vue');

var _EditorTextAlignLeft2 = _interopRequireDefault(_EditorTextAlignLeft);

var _EditorTextAlignRight = require('./icons/EditorTextAlignRight.vue');

var _EditorTextAlignRight2 = _interopRequireDefault(_EditorTextAlignRight);

var _EditorTextBoldOutline = require('./icons/EditorTextBoldOutline.vue');

var _EditorTextBoldOutline2 = _interopRequireDefault(_EditorTextBoldOutline);

var _EditorTextItalicOutline = require('./icons/EditorTextItalicOutline.vue');

var _EditorTextItalicOutline2 = _interopRequireDefault(_EditorTextItalicOutline);

var _EditorTitleOutline = require('./icons/EditorTitleOutline.vue');

var _EditorTitleOutline2 = _interopRequireDefault(_EditorTitleOutline);

var _EmoteHappyFilled = require('./icons/EmoteHappyFilled.vue');

var _EmoteHappyFilled2 = _interopRequireDefault(_EmoteHappyFilled);

var _EmoteHappyOutline = require('./icons/EmoteHappyOutline.vue');

var _EmoteHappyOutline2 = _interopRequireDefault(_EmoteHappyOutline);

var _EmoteSadFilled = require('./icons/EmoteSadFilled.vue');

var _EmoteSadFilled2 = _interopRequireDefault(_EmoteSadFilled);

var _EmoteSadOutline = require('./icons/EmoteSadOutline.vue');

var _EmoteSadOutline2 = _interopRequireDefault(_EmoteSadOutline);

var _FilesCheckFilled = require('./icons/FilesCheckFilled.vue');

var _FilesCheckFilled2 = _interopRequireDefault(_FilesCheckFilled);

var _FilesCheckOutline = require('./icons/FilesCheckOutline.vue');

var _FilesCheckOutline2 = _interopRequireDefault(_FilesCheckOutline);

var _FilesCloseFilled = require('./icons/FilesCloseFilled.vue');

var _FilesCloseFilled2 = _interopRequireDefault(_FilesCloseFilled);

var _FilesCloseOutline = require('./icons/FilesCloseOutline.vue');

var _FilesCloseOutline2 = _interopRequireDefault(_FilesCloseOutline);

var _FilesFile = require('./icons/FilesFile.vue');

var _FilesFile2 = _interopRequireDefault(_FilesFile);

var _FilesHistoryFilled = require('./icons/FilesHistoryFilled.vue');

var _FilesHistoryFilled2 = _interopRequireDefault(_FilesHistoryFilled);

var _FilesHistoryOutline = require('./icons/FilesHistoryOutline.vue');

var _FilesHistoryOutline2 = _interopRequireDefault(_FilesHistoryOutline);

var _FilesMinusFilled = require('./icons/FilesMinusFilled.vue');

var _FilesMinusFilled2 = _interopRequireDefault(_FilesMinusFilled);

var _FilesMinusOutline = require('./icons/FilesMinusOutline.vue');

var _FilesMinusOutline2 = _interopRequireDefault(_FilesMinusOutline);

var _FilesPlusFilled = require('./icons/FilesPlusFilled.vue');

var _FilesPlusFilled2 = _interopRequireDefault(_FilesPlusFilled);

var _FilesPlusOutline = require('./icons/FilesPlusOutline.vue');

var _FilesPlusOutline2 = _interopRequireDefault(_FilesPlusOutline);

var _FilesReportsOutline = require('./icons/FilesReportsOutline.vue');

var _FilesReportsOutline2 = _interopRequireDefault(_FilesReportsOutline);

var _FilesSearchFilled = require('./icons/FilesSearchFilled.vue');

var _FilesSearchFilled2 = _interopRequireDefault(_FilesSearchFilled);

var _FilesSearchOutline = require('./icons/FilesSearchOutline.vue');

var _FilesSearchOutline2 = _interopRequireDefault(_FilesSearchOutline);

var _FilesStatementFilled = require('./icons/FilesStatementFilled.vue');

var _FilesStatementFilled2 = _interopRequireDefault(_FilesStatementFilled);

var _FilesStatementOutline = require('./icons/FilesStatementOutline.vue');

var _FilesStatementOutline2 = _interopRequireDefault(_FilesStatementOutline);

var _FilesTextFileFilled = require('./icons/FilesTextFileFilled.vue');

var _FilesTextFileFilled2 = _interopRequireDefault(_FilesTextFileFilled);

var _FilesTextFileOutline = require('./icons/FilesTextFileOutline.vue');

var _FilesTextFileOutline2 = _interopRequireDefault(_FilesTextFileOutline);

var _FinanceCashFilled = require('./icons/FinanceCashFilled.vue');

var _FinanceCashFilled2 = _interopRequireDefault(_FinanceCashFilled);

var _FinanceCashOutline = require('./icons/FinanceCashOutline.vue');

var _FinanceCashOutline2 = _interopRequireDefault(_FinanceCashOutline);

var _FinanceCircleDollarSignFilled = require('./icons/FinanceCircleDollarSignFilled.vue');

var _FinanceCircleDollarSignFilled2 = _interopRequireDefault(_FinanceCircleDollarSignFilled);

var _FinanceCircleDollarSignOutline = require('./icons/FinanceCircleDollarSignOutline.vue');

var _FinanceCircleDollarSignOutline2 = _interopRequireDefault(_FinanceCircleDollarSignOutline);

var _FinanceCreditCardFilled = require('./icons/FinanceCreditCardFilled.vue');

var _FinanceCreditCardFilled2 = _interopRequireDefault(_FinanceCreditCardFilled);

var _FinanceCreditCardOutline = require('./icons/FinanceCreditCardOutline.vue');

var _FinanceCreditCardOutline2 = _interopRequireDefault(_FinanceCreditCardOutline);

var _FinanceCreditCardsFilled = require('./icons/FinanceCreditCardsFilled.vue');

var _FinanceCreditCardsFilled2 = _interopRequireDefault(_FinanceCreditCardsFilled);

var _FinanceCreditCardsOutline = require('./icons/FinanceCreditCardsOutline.vue');

var _FinanceCreditCardsOutline2 = _interopRequireDefault(_FinanceCreditCardsOutline);

var _FinanceDollarSignOffOutline = require('./icons/FinanceDollarSignOffOutline.vue');

var _FinanceDollarSignOffOutline2 = _interopRequireDefault(_FinanceDollarSignOffOutline);

var _FinanceDollarSignOutline = require('./icons/FinanceDollarSignOutline.vue');

var _FinanceDollarSignOutline2 = _interopRequireDefault(_FinanceDollarSignOutline);

var _HardwareCpuFilled = require('./icons/HardwareCpuFilled.vue');

var _HardwareCpuFilled2 = _interopRequireDefault(_HardwareCpuFilled);

var _HardwareCpuOutline = require('./icons/HardwareCpuOutline.vue');

var _HardwareCpuOutline2 = _interopRequireDefault(_HardwareCpuOutline);

var _HardwareHddFilled = require('./icons/HardwareHddFilled.vue');

var _HardwareHddFilled2 = _interopRequireDefault(_HardwareHddFilled);

var _HardwareHddOutline = require('./icons/HardwareHddOutline.vue');

var _HardwareHddOutline2 = _interopRequireDefault(_HardwareHddOutline);

var _HardwareMemoryFilled = require('./icons/HardwareMemoryFilled.vue');

var _HardwareMemoryFilled2 = _interopRequireDefault(_HardwareMemoryFilled);

var _HardwareMemoryOutline = require('./icons/HardwareMemoryOutline.vue');

var _HardwareMemoryOutline2 = _interopRequireDefault(_HardwareMemoryOutline);

var _HardwareSsdFilled = require('./icons/HardwareSsdFilled.vue');

var _HardwareSsdFilled2 = _interopRequireDefault(_HardwareSsdFilled);

var _HardwareSsdOutline = require('./icons/HardwareSsdOutline.vue');

var _HardwareSsdOutline2 = _interopRequireDefault(_HardwareSsdOutline);

var _LocalizationGlobeFilled = require('./icons/LocalizationGlobeFilled.vue');

var _LocalizationGlobeFilled2 = _interopRequireDefault(_LocalizationGlobeFilled);

var _LocalizationGlobeOutline = require('./icons/LocalizationGlobeOutline.vue');

var _LocalizationGlobeOutline2 = _interopRequireDefault(_LocalizationGlobeOutline);

var _LocalizationGlobePinnedFilled = require('./icons/LocalizationGlobePinnedFilled.vue');

var _LocalizationGlobePinnedFilled2 = _interopRequireDefault(_LocalizationGlobePinnedFilled);

var _LocalizationGlobePinnedOutline = require('./icons/LocalizationGlobePinnedOutline.vue');

var _LocalizationGlobePinnedOutline2 = _interopRequireDefault(_LocalizationGlobePinnedOutline);

var _LocalizationGlobePlusFilled = require('./icons/LocalizationGlobePlusFilled.vue');

var _LocalizationGlobePlusFilled2 = _interopRequireDefault(_LocalizationGlobePlusFilled);

var _LocalizationGlobePlusOutline = require('./icons/LocalizationGlobePlusOutline.vue');

var _LocalizationGlobePlusOutline2 = _interopRequireDefault(_LocalizationGlobePlusOutline);

var _LocalizationPinFilled = require('./icons/LocalizationPinFilled.vue');

var _LocalizationPinFilled2 = _interopRequireDefault(_LocalizationPinFilled);

var _LocalizationPinOutline = require('./icons/LocalizationPinOutline.vue');

var _LocalizationPinOutline2 = _interopRequireDefault(_LocalizationPinOutline);

var _MediaImageExpandedFilled = require('./icons/MediaImageExpandedFilled.vue');

var _MediaImageExpandedFilled2 = _interopRequireDefault(_MediaImageExpandedFilled);

var _MediaImageExpandedOutline = require('./icons/MediaImageExpandedOutline.vue');

var _MediaImageExpandedOutline2 = _interopRequireDefault(_MediaImageExpandedOutline);

var _MediaImageFilled = require('./icons/MediaImageFilled.vue');

var _MediaImageFilled2 = _interopRequireDefault(_MediaImageFilled);

var _MediaImageOutline = require('./icons/MediaImageOutline.vue');

var _MediaImageOutline2 = _interopRequireDefault(_MediaImageOutline);

var _MediaPauseFilled = require('./icons/MediaPauseFilled.vue');

var _MediaPauseFilled2 = _interopRequireDefault(_MediaPauseFilled);

var _MediaPauseOutline = require('./icons/MediaPauseOutline.vue');

var _MediaPauseOutline2 = _interopRequireDefault(_MediaPauseOutline);

var _MediaPlayFilled = require('./icons/MediaPlayFilled.vue');

var _MediaPlayFilled2 = _interopRequireDefault(_MediaPlayFilled);

var _MediaPlayOutline = require('./icons/MediaPlayOutline.vue');

var _MediaPlayOutline2 = _interopRequireDefault(_MediaPlayOutline);

var _MediaVolumeOffFilled = require('./icons/MediaVolumeOffFilled.vue');

var _MediaVolumeOffFilled2 = _interopRequireDefault(_MediaVolumeOffFilled);

var _MediaVolumeOffOutline = require('./icons/MediaVolumeOffOutline.vue');

var _MediaVolumeOffOutline2 = _interopRequireDefault(_MediaVolumeOffOutline);

var _MediaVolumeOnFilled = require('./icons/MediaVolumeOnFilled.vue');

var _MediaVolumeOnFilled2 = _interopRequireDefault(_MediaVolumeOnFilled);

var _MediaVolumeOnOutline = require('./icons/MediaVolumeOnOutline.vue');

var _MediaVolumeOnOutline2 = _interopRequireDefault(_MediaVolumeOnOutline);

var _ObjectsBalanceFilled = require('./icons/ObjectsBalanceFilled.vue');

var _ObjectsBalanceFilled2 = _interopRequireDefault(_ObjectsBalanceFilled);

var _ObjectsBalanceOutline = require('./icons/ObjectsBalanceOutline.vue');

var _ObjectsBalanceOutline2 = _interopRequireDefault(_ObjectsBalanceOutline);

var _ObjectsBellFilled = require('./icons/ObjectsBellFilled.vue');

var _ObjectsBellFilled2 = _interopRequireDefault(_ObjectsBellFilled);

var _ObjectsBellOffFilled = require('./icons/ObjectsBellOffFilled.vue');

var _ObjectsBellOffFilled2 = _interopRequireDefault(_ObjectsBellOffFilled);

var _ObjectsBellOffOutline = require('./icons/ObjectsBellOffOutline.vue');

var _ObjectsBellOffOutline2 = _interopRequireDefault(_ObjectsBellOffOutline);

var _ObjectsBellOutline = require('./icons/ObjectsBellOutline.vue');

var _ObjectsBellOutline2 = _interopRequireDefault(_ObjectsBellOutline);

var _ObjectsBoxFilled = require('./icons/ObjectsBoxFilled.vue');

var _ObjectsBoxFilled2 = _interopRequireDefault(_ObjectsBoxFilled);

var _ObjectsBoxOutline = require('./icons/ObjectsBoxOutline.vue');

var _ObjectsBoxOutline2 = _interopRequireDefault(_ObjectsBoxOutline);

var _ObjectsCalculatorFilled = require('./icons/ObjectsCalculatorFilled.vue');

var _ObjectsCalculatorFilled2 = _interopRequireDefault(_ObjectsCalculatorFilled);

var _ObjectsCalculatorOutline = require('./icons/ObjectsCalculatorOutline.vue');

var _ObjectsCalculatorOutline2 = _interopRequireDefault(_ObjectsCalculatorOutline);

var _ObjectsCalendarFilled = require('./icons/ObjectsCalendarFilled.vue');

var _ObjectsCalendarFilled2 = _interopRequireDefault(_ObjectsCalendarFilled);

var _ObjectsCalendarOutline = require('./icons/ObjectsCalendarOutline.vue');

var _ObjectsCalendarOutline2 = _interopRequireDefault(_ObjectsCalendarOutline);

var _ObjectsCameraFilled = require('./icons/ObjectsCameraFilled.vue');

var _ObjectsCameraFilled2 = _interopRequireDefault(_ObjectsCameraFilled);

var _ObjectsCameraOutline = require('./icons/ObjectsCameraOutline.vue');

var _ObjectsCameraOutline2 = _interopRequireDefault(_ObjectsCameraOutline);

var _ObjectsCdFilled = require('./icons/ObjectsCdFilled.vue');

var _ObjectsCdFilled2 = _interopRequireDefault(_ObjectsCdFilled);

var _ObjectsCdOutline = require('./icons/ObjectsCdOutline.vue');

var _ObjectsCdOutline2 = _interopRequireDefault(_ObjectsCdOutline);

var _ObjectsClockFilled = require('./icons/ObjectsClockFilled.vue');

var _ObjectsClockFilled2 = _interopRequireDefault(_ObjectsClockFilled);

var _ObjectsClockOutline = require('./icons/ObjectsClockOutline.vue');

var _ObjectsClockOutline2 = _interopRequireDefault(_ObjectsClockOutline);

var _ObjectsCompassOutline = require('./icons/ObjectsCompassOutline.vue');

var _ObjectsCompassOutline2 = _interopRequireDefault(_ObjectsCompassOutline);

var _ObjectsEraserOutline = require('./icons/ObjectsEraserOutline.vue');

var _ObjectsEraserOutline2 = _interopRequireDefault(_ObjectsEraserOutline);

var _ObjectsFloppyDiskFilled = require('./icons/ObjectsFloppyDiskFilled.vue');

var _ObjectsFloppyDiskFilled2 = _interopRequireDefault(_ObjectsFloppyDiskFilled);

var _ObjectsFloppyDiskOutline = require('./icons/ObjectsFloppyDiskOutline.vue');

var _ObjectsFloppyDiskOutline2 = _interopRequireDefault(_ObjectsFloppyDiskOutline);

var _ObjectsFolderFilled = require('./icons/ObjectsFolderFilled.vue');

var _ObjectsFolderFilled2 = _interopRequireDefault(_ObjectsFolderFilled);

var _ObjectsFolderOutline = require('./icons/ObjectsFolderOutline.vue');

var _ObjectsFolderOutline2 = _interopRequireDefault(_ObjectsFolderOutline);

var _ObjectsFunnelFilled = require('./icons/ObjectsFunnelFilled.vue');

var _ObjectsFunnelFilled2 = _interopRequireDefault(_ObjectsFunnelFilled);

var _ObjectsFunnelOutline = require('./icons/ObjectsFunnelOutline.vue');

var _ObjectsFunnelOutline2 = _interopRequireDefault(_ObjectsFunnelOutline);

var _ObjectsGearFilled = require('./icons/ObjectsGearFilled.vue');

var _ObjectsGearFilled2 = _interopRequireDefault(_ObjectsGearFilled);

var _ObjectsGearOutline = require('./icons/ObjectsGearOutline.vue');

var _ObjectsGearOutline2 = _interopRequireDefault(_ObjectsGearOutline);

var _ObjectsGiftOutline = require('./icons/ObjectsGiftOutline.vue');

var _ObjectsGiftOutline2 = _interopRequireDefault(_ObjectsGiftOutline);

var _ObjectsHeadphoneFilled = require('./icons/ObjectsHeadphoneFilled.vue');

var _ObjectsHeadphoneFilled2 = _interopRequireDefault(_ObjectsHeadphoneFilled);

var _ObjectsHeadphoneOutline = require('./icons/ObjectsHeadphoneOutline.vue');

var _ObjectsHeadphoneOutline2 = _interopRequireDefault(_ObjectsHeadphoneOutline);

var _ObjectsKeyOutline = require('./icons/ObjectsKeyOutline.vue');

var _ObjectsKeyOutline2 = _interopRequireDefault(_ObjectsKeyOutline);

var _ObjectsLampFilled = require('./icons/ObjectsLampFilled.vue');

var _ObjectsLampFilled2 = _interopRequireDefault(_ObjectsLampFilled);

var _ObjectsLampOnFilled = require('./icons/ObjectsLampOnFilled.vue');

var _ObjectsLampOnFilled2 = _interopRequireDefault(_ObjectsLampOnFilled);

var _ObjectsLampOnOutline = require('./icons/ObjectsLampOnOutline.vue');

var _ObjectsLampOnOutline2 = _interopRequireDefault(_ObjectsLampOnOutline);

var _ObjectsLampOutline = require('./icons/ObjectsLampOutline.vue');

var _ObjectsLampOutline2 = _interopRequireDefault(_ObjectsLampOutline);

var _ObjectsLockFilled = require('./icons/ObjectsLockFilled.vue');

var _ObjectsLockFilled2 = _interopRequireDefault(_ObjectsLockFilled);

var _ObjectsLockOpenFilled = require('./icons/ObjectsLockOpenFilled.vue');

var _ObjectsLockOpenFilled2 = _interopRequireDefault(_ObjectsLockOpenFilled);

var _ObjectsLockOpenOutline = require('./icons/ObjectsLockOpenOutline.vue');

var _ObjectsLockOpenOutline2 = _interopRequireDefault(_ObjectsLockOpenOutline);

var _ObjectsLockOutline = require('./icons/ObjectsLockOutline.vue');

var _ObjectsLockOutline2 = _interopRequireDefault(_ObjectsLockOutline);

var _ObjectsMagnifyOutline = require('./icons/ObjectsMagnifyOutline.vue');

var _ObjectsMagnifyOutline2 = _interopRequireDefault(_ObjectsMagnifyOutline);

var _ObjectsMailFilled = require('./icons/ObjectsMailFilled.vue');

var _ObjectsMailFilled2 = _interopRequireDefault(_ObjectsMailFilled);

var _ObjectsMailOpenFilled = require('./icons/ObjectsMailOpenFilled.vue');

var _ObjectsMailOpenFilled2 = _interopRequireDefault(_ObjectsMailOpenFilled);

var _ObjectsMailOpenOutline = require('./icons/ObjectsMailOpenOutline.vue');

var _ObjectsMailOpenOutline2 = _interopRequireDefault(_ObjectsMailOpenOutline);

var _ObjectsMailOutline = require('./icons/ObjectsMailOutline.vue');

var _ObjectsMailOutline2 = _interopRequireDefault(_ObjectsMailOutline);

var _ObjectsMegaphoneOutline = require('./icons/ObjectsMegaphoneOutline.vue');

var _ObjectsMegaphoneOutline2 = _interopRequireDefault(_ObjectsMegaphoneOutline);

var _ObjectsMicrophoneFilled = require('./icons/ObjectsMicrophoneFilled.vue');

var _ObjectsMicrophoneFilled2 = _interopRequireDefault(_ObjectsMicrophoneFilled);

var _ObjectsMicrophoneOutline = require('./icons/ObjectsMicrophoneOutline.vue');

var _ObjectsMicrophoneOutline2 = _interopRequireDefault(_ObjectsMicrophoneOutline);

var _ObjectsPaintBucketFilled = require('./icons/ObjectsPaintBucketFilled.vue');

var _ObjectsPaintBucketFilled2 = _interopRequireDefault(_ObjectsPaintBucketFilled);

var _ObjectsPaintBucketOutline = require('./icons/ObjectsPaintBucketOutline.vue');

var _ObjectsPaintBucketOutline2 = _interopRequireDefault(_ObjectsPaintBucketOutline);

var _ObjectsPaperclipOutline = require('./icons/ObjectsPaperclipOutline.vue');

var _ObjectsPaperclipOutline2 = _interopRequireDefault(_ObjectsPaperclipOutline);

var _ObjectsPencilFilled = require('./icons/ObjectsPencilFilled.vue');

var _ObjectsPencilFilled2 = _interopRequireDefault(_ObjectsPencilFilled);

var _ObjectsPencilOutline = require('./icons/ObjectsPencilOutline.vue');

var _ObjectsPencilOutline2 = _interopRequireDefault(_ObjectsPencilOutline);

var _ObjectsPhoneFilled = require('./icons/ObjectsPhoneFilled.vue');

var _ObjectsPhoneFilled2 = _interopRequireDefault(_ObjectsPhoneFilled);

var _ObjectsPhoneOutline = require('./icons/ObjectsPhoneOutline.vue');

var _ObjectsPhoneOutline2 = _interopRequireDefault(_ObjectsPhoneOutline);

var _ObjectsPickerOutline = require('./icons/ObjectsPickerOutline.vue');

var _ObjectsPickerOutline2 = _interopRequireDefault(_ObjectsPickerOutline);

var _ObjectsPrinterFilled = require('./icons/ObjectsPrinterFilled.vue');

var _ObjectsPrinterFilled2 = _interopRequireDefault(_ObjectsPrinterFilled);

var _ObjectsPrinterOutline = require('./icons/ObjectsPrinterOutline.vue');

var _ObjectsPrinterOutline2 = _interopRequireDefault(_ObjectsPrinterOutline);

var _ObjectsPuzzleFilled = require('./icons/ObjectsPuzzleFilled.vue');

var _ObjectsPuzzleFilled2 = _interopRequireDefault(_ObjectsPuzzleFilled);

var _ObjectsPuzzleOutline = require('./icons/ObjectsPuzzleOutline.vue');

var _ObjectsPuzzleOutline2 = _interopRequireDefault(_ObjectsPuzzleOutline);

var _ObjectsSignFilled = require('./icons/ObjectsSignFilled.vue');

var _ObjectsSignFilled2 = _interopRequireDefault(_ObjectsSignFilled);

var _ObjectsSignOutline = require('./icons/ObjectsSignOutline.vue');

var _ObjectsSignOutline2 = _interopRequireDefault(_ObjectsSignOutline);

var _ObjectsStopwatchFilled = require('./icons/ObjectsStopwatchFilled.vue');

var _ObjectsStopwatchFilled2 = _interopRequireDefault(_ObjectsStopwatchFilled);

var _ObjectsStopwatchOutline = require('./icons/ObjectsStopwatchOutline.vue');

var _ObjectsStopwatchOutline2 = _interopRequireDefault(_ObjectsStopwatchOutline);

var _ObjectsToolFilled = require('./icons/ObjectsToolFilled.vue');

var _ObjectsToolFilled2 = _interopRequireDefault(_ObjectsToolFilled);

var _ObjectsToolOutline = require('./icons/ObjectsToolOutline.vue');

var _ObjectsToolOutline2 = _interopRequireDefault(_ObjectsToolOutline);

var _ObjectsTrashFilled = require('./icons/ObjectsTrashFilled.vue');

var _ObjectsTrashFilled2 = _interopRequireDefault(_ObjectsTrashFilled);

var _ObjectsTrashOutline = require('./icons/ObjectsTrashOutline.vue');

var _ObjectsTrashOutline2 = _interopRequireDefault(_ObjectsTrashOutline);

var _ObjectsVideocameraFilled = require('./icons/ObjectsVideocameraFilled.vue');

var _ObjectsVideocameraFilled2 = _interopRequireDefault(_ObjectsVideocameraFilled);

var _ObjectsVideocameraOutline = require('./icons/ObjectsVideocameraOutline.vue');

var _ObjectsVideocameraOutline2 = _interopRequireDefault(_ObjectsVideocameraOutline);

var _ObjectsWandOutline = require('./icons/ObjectsWandOutline.vue');

var _ObjectsWandOutline2 = _interopRequireDefault(_ObjectsWandOutline);

var _PlacesHomeFilled = require('./icons/PlacesHomeFilled.vue');

var _PlacesHomeFilled2 = _interopRequireDefault(_PlacesHomeFilled);

var _PlacesHomeOutline = require('./icons/PlacesHomeOutline.vue');

var _PlacesHomeOutline2 = _interopRequireDefault(_PlacesHomeOutline);

var _PlacesStoreOutline = require('./icons/PlacesStoreOutline.vue');

var _PlacesStoreOutline2 = _interopRequireDefault(_PlacesStoreOutline);

var _SecurityFirewallOutline = require('./icons/SecurityFirewallOutline.vue');

var _SecurityFirewallOutline2 = _interopRequireDefault(_SecurityFirewallOutline);

var _SecurityShieldAlertFilled = require('./icons/SecurityShieldAlertFilled.vue');

var _SecurityShieldAlertFilled2 = _interopRequireDefault(_SecurityShieldAlertFilled);

var _SecurityShieldAlertOutline = require('./icons/SecurityShieldAlertOutline.vue');

var _SecurityShieldAlertOutline2 = _interopRequireDefault(_SecurityShieldAlertOutline);

var _SecurityShieldFilled = require('./icons/SecurityShieldFilled.vue');

var _SecurityShieldFilled2 = _interopRequireDefault(_SecurityShieldFilled);

var _SecurityShieldLockFilled = require('./icons/SecurityShieldLockFilled.vue');

var _SecurityShieldLockFilled2 = _interopRequireDefault(_SecurityShieldLockFilled);

var _SecurityShieldLockOpenFilled = require('./icons/SecurityShieldLockOpenFilled.vue');

var _SecurityShieldLockOpenFilled2 = _interopRequireDefault(_SecurityShieldLockOpenFilled);

var _SecurityShieldLockOpenOutline = require('./icons/SecurityShieldLockOpenOutline.vue');

var _SecurityShieldLockOpenOutline2 = _interopRequireDefault(_SecurityShieldLockOpenOutline);

var _SecurityShieldLockOutline = require('./icons/SecurityShieldLockOutline.vue');

var _SecurityShieldLockOutline2 = _interopRequireDefault(_SecurityShieldLockOutline);

var _SecurityShieldOutline = require('./icons/SecurityShieldOutline.vue');

var _SecurityShieldOutline2 = _interopRequireDefault(_SecurityShieldOutline);

var _ServerCloudFilled = require('./icons/ServerCloudFilled.vue');

var _ServerCloudFilled2 = _interopRequireDefault(_ServerCloudFilled);

var _ServerCloudOutline = require('./icons/ServerCloudOutline.vue');

var _ServerCloudOutline2 = _interopRequireDefault(_ServerCloudOutline);

var _ServerDatabaseFilled = require('./icons/ServerDatabaseFilled.vue');

var _ServerDatabaseFilled2 = _interopRequireDefault(_ServerDatabaseFilled);

var _ServerDatabaseOutline = require('./icons/ServerDatabaseOutline.vue');

var _ServerDatabaseOutline2 = _interopRequireDefault(_ServerDatabaseOutline);

var _ServerDnsFilled = require('./icons/ServerDnsFilled.vue');

var _ServerDnsFilled2 = _interopRequireDefault(_ServerDnsFilled);

var _ServerDnsOutline = require('./icons/ServerDnsOutline.vue');

var _ServerDnsOutline2 = _interopRequireDefault(_ServerDnsOutline);

var _ServerDownloadOutline = require('./icons/ServerDownloadOutline.vue');

var _ServerDownloadOutline2 = _interopRequireDefault(_ServerDownloadOutline);

var _ServerFtpFilled = require('./icons/ServerFtpFilled.vue');

var _ServerFtpFilled2 = _interopRequireDefault(_ServerFtpFilled);

var _ServerFtpOutline = require('./icons/ServerFtpOutline.vue');

var _ServerFtpOutline2 = _interopRequireDefault(_ServerFtpOutline);

var _ServerUploadOutline = require('./icons/ServerUploadOutline.vue');

var _ServerUploadOutline2 = _interopRequireDefault(_ServerUploadOutline);

var _ServicesClicLead = require('./icons/ServicesClicLead.vue');

var _ServicesClicLead2 = _interopRequireDefault(_ServicesClicLead);

var _ServicesCloudServerPro = require('./icons/ServicesCloudServerPro.vue');

var _ServicesCloudServerPro2 = _interopRequireDefault(_ServicesCloudServerPro);

var _ServicesCriadorDeSites = require('./icons/ServicesCriadorDeSites.vue');

var _ServicesCriadorDeSites2 = _interopRequireDefault(_ServicesCriadorDeSites);

var _ServicesEmailExchange = require('./icons/ServicesEmailExchange.vue');

var _ServicesEmailExchange2 = _interopRequireDefault(_ServicesEmailExchange);

var _ServicesEmailGo = require('./icons/ServicesEmailGo.vue');

var _ServicesEmailGo2 = _interopRequireDefault(_ServicesEmailGo);

var _ServicesEmailLocaweb = require('./icons/ServicesEmailLocaweb.vue');

var _ServicesEmailLocaweb2 = _interopRequireDefault(_ServicesEmailLocaweb);

var _ServicesEmailMarketing = require('./icons/ServicesEmailMarketing.vue');

var _ServicesEmailMarketing2 = _interopRequireDefault(_ServicesEmailMarketing);

var _ServicesGoogleWorkspace = require('./icons/ServicesGoogleWorkspace.vue');

var _ServicesGoogleWorkspace2 = _interopRequireDefault(_ServicesGoogleWorkspace);

var _ServicesHospedagemDeSites = require('./icons/ServicesHospedagemDeSites.vue');

var _ServicesHospedagemDeSites2 = _interopRequireDefault(_ServicesHospedagemDeSites);

var _ServicesHospedagemDedicada = require('./icons/ServicesHospedagemDedicada.vue');

var _ServicesHospedagemDedicada2 = _interopRequireDefault(_ServicesHospedagemDedicada);

var _ServicesHospedagemWordpress = require('./icons/ServicesHospedagemWordpress.vue');

var _ServicesHospedagemWordpress2 = _interopRequireDefault(_ServicesHospedagemWordpress);

var _ServicesRegistroDeDominio = require('./icons/ServicesRegistroDeDominio.vue');

var _ServicesRegistroDeDominio2 = _interopRequireDefault(_ServicesRegistroDeDominio);

var _ServicesRevenda = require('./icons/ServicesRevenda.vue');

var _ServicesRevenda2 = _interopRequireDefault(_ServicesRevenda);

var _ServicesSmtp = require('./icons/ServicesSmtp.vue');

var _ServicesSmtp2 = _interopRequireDefault(_ServicesSmtp);

var _ServicesSsl = require('./icons/ServicesSsl.vue');

var _ServicesSsl2 = _interopRequireDefault(_ServicesSsl);

var _ServicesVps = require('./icons/ServicesVps.vue');

var _ServicesVps2 = _interopRequireDefault(_ServicesVps);

var _ShopAddToCartFilled = require('./icons/ShopAddToCartFilled.vue');

var _ShopAddToCartFilled2 = _interopRequireDefault(_ShopAddToCartFilled);

var _ShopAddToCartOutline = require('./icons/ShopAddToCartOutline.vue');

var _ShopAddToCartOutline2 = _interopRequireDefault(_ShopAddToCartOutline);

var _ShopBarcodeOutline = require('./icons/ShopBarcodeOutline.vue');

var _ShopBarcodeOutline2 = _interopRequireDefault(_ShopBarcodeOutline);

var _ShopTagFilled = require('./icons/ShopTagFilled.vue');

var _ShopTagFilled2 = _interopRequireDefault(_ShopTagFilled);

var _ShopTagOutline = require('./icons/ShopTagOutline.vue');

var _ShopTagOutline2 = _interopRequireDefault(_ShopTagOutline);

var _ShopTicketFilled = require('./icons/ShopTicketFilled.vue');

var _ShopTicketFilled2 = _interopRequireDefault(_ShopTicketFilled);

var _ShopTicketOutline = require('./icons/ShopTicketOutline.vue');

var _ShopTicketOutline2 = _interopRequireDefault(_ShopTicketOutline);

var _SymbolsAdjustOutline = require('./icons/SymbolsAdjustOutline.vue');

var _SymbolsAdjustOutline2 = _interopRequireDefault(_SymbolsAdjustOutline);

var _SymbolsAlertFilled = require('./icons/SymbolsAlertFilled.vue');

var _SymbolsAlertFilled2 = _interopRequireDefault(_SymbolsAlertFilled);

var _SymbolsAlertOutline = require('./icons/SymbolsAlertOutline.vue');

var _SymbolsAlertOutline2 = _interopRequireDefault(_SymbolsAlertOutline);

var _SymbolsBarChartOutline = require('./icons/SymbolsBarChartOutline.vue');

var _SymbolsBarChartOutline2 = _interopRequireDefault(_SymbolsBarChartOutline);

var _SymbolsBarsLeftOutline = require('./icons/SymbolsBarsLeftOutline.vue');

var _SymbolsBarsLeftOutline2 = _interopRequireDefault(_SymbolsBarsLeftOutline);

var _SymbolsBarsOutline = require('./icons/SymbolsBarsOutline.vue');

var _SymbolsBarsOutline2 = _interopRequireDefault(_SymbolsBarsOutline);

var _SymbolsBarsRightOutline = require('./icons/SymbolsBarsRightOutline.vue');

var _SymbolsBarsRightOutline2 = _interopRequireDefault(_SymbolsBarsRightOutline);

var _SymbolsBookmarkFilled = require('./icons/SymbolsBookmarkFilled.vue');

var _SymbolsBookmarkFilled2 = _interopRequireDefault(_SymbolsBookmarkFilled);

var _SymbolsBookmarkOutline = require('./icons/SymbolsBookmarkOutline.vue');

var _SymbolsBookmarkOutline2 = _interopRequireDefault(_SymbolsBookmarkOutline);

var _SymbolsBroadcastOutline = require('./icons/SymbolsBroadcastOutline.vue');

var _SymbolsBroadcastOutline2 = _interopRequireDefault(_SymbolsBroadcastOutline);

var _SymbolsCheckOutline = require('./icons/SymbolsCheckOutline.vue');

var _SymbolsCheckOutline2 = _interopRequireDefault(_SymbolsCheckOutline);

var _SymbolsCheckboxIndeterminatedFilled = require('./icons/SymbolsCheckboxIndeterminatedFilled.vue');

var _SymbolsCheckboxIndeterminatedFilled2 = _interopRequireDefault(_SymbolsCheckboxIndeterminatedFilled);

var _SymbolsCheckboxIndeterminatedOutline = require('./icons/SymbolsCheckboxIndeterminatedOutline.vue');

var _SymbolsCheckboxIndeterminatedOutline2 = _interopRequireDefault(_SymbolsCheckboxIndeterminatedOutline);

var _SymbolsCheckboxOutline = require('./icons/SymbolsCheckboxOutline.vue');

var _SymbolsCheckboxOutline2 = _interopRequireDefault(_SymbolsCheckboxOutline);

var _SymbolsCheckboxSelectedFilled = require('./icons/SymbolsCheckboxSelectedFilled.vue');

var _SymbolsCheckboxSelectedFilled2 = _interopRequireDefault(_SymbolsCheckboxSelectedFilled);

var _SymbolsCheckboxSelectedOutline = require('./icons/SymbolsCheckboxSelectedOutline.vue');

var _SymbolsCheckboxSelectedOutline2 = _interopRequireDefault(_SymbolsCheckboxSelectedOutline);

var _SymbolsCircleAlertFilled = require('./icons/SymbolsCircleAlertFilled.vue');

var _SymbolsCircleAlertFilled2 = _interopRequireDefault(_SymbolsCircleAlertFilled);

var _SymbolsCircleAlertOutline = require('./icons/SymbolsCircleAlertOutline.vue');

var _SymbolsCircleAlertOutline2 = _interopRequireDefault(_SymbolsCircleAlertOutline);

var _SymbolsCircleCheckFilled = require('./icons/SymbolsCircleCheckFilled.vue');

var _SymbolsCircleCheckFilled2 = _interopRequireDefault(_SymbolsCircleCheckFilled);

var _SymbolsCircleCheckOutline = require('./icons/SymbolsCircleCheckOutline.vue');

var _SymbolsCircleCheckOutline2 = _interopRequireDefault(_SymbolsCircleCheckOutline);

var _SymbolsCircleCloseFilled = require('./icons/SymbolsCircleCloseFilled.vue');

var _SymbolsCircleCloseFilled2 = _interopRequireDefault(_SymbolsCircleCloseFilled);

var _SymbolsCircleCloseOutline = require('./icons/SymbolsCircleCloseOutline.vue');

var _SymbolsCircleCloseOutline2 = _interopRequireDefault(_SymbolsCircleCloseOutline);

var _SymbolsCircleHelpFilled = require('./icons/SymbolsCircleHelpFilled.vue');

var _SymbolsCircleHelpFilled2 = _interopRequireDefault(_SymbolsCircleHelpFilled);

var _SymbolsCircleHelpOutline = require('./icons/SymbolsCircleHelpOutline.vue');

var _SymbolsCircleHelpOutline2 = _interopRequireDefault(_SymbolsCircleHelpOutline);

var _SymbolsCircleInfoFilled = require('./icons/SymbolsCircleInfoFilled.vue');

var _SymbolsCircleInfoFilled2 = _interopRequireDefault(_SymbolsCircleInfoFilled);

var _SymbolsCircleInfoOutline = require('./icons/SymbolsCircleInfoOutline.vue');

var _SymbolsCircleInfoOutline2 = _interopRequireDefault(_SymbolsCircleInfoOutline);

var _SymbolsCirclePlusFilled = require('./icons/SymbolsCirclePlusFilled.vue');

var _SymbolsCirclePlusFilled2 = _interopRequireDefault(_SymbolsCirclePlusFilled);

var _SymbolsCirclePlusOutline = require('./icons/SymbolsCirclePlusOutline.vue');

var _SymbolsCirclePlusOutline2 = _interopRequireDefault(_SymbolsCirclePlusOutline);

var _SymbolsCircle = require('./icons/SymbolsCircle.vue');

var _SymbolsCircle2 = _interopRequireDefault(_SymbolsCircle);

var _SymbolsCloseOutline = require('./icons/SymbolsCloseOutline.vue');

var _SymbolsCloseOutline2 = _interopRequireDefault(_SymbolsCloseOutline);

var _SymbolsCloudFilled = require('./icons/SymbolsCloudFilled.vue');

var _SymbolsCloudFilled2 = _interopRequireDefault(_SymbolsCloudFilled);

var _SymbolsCloudOutline = require('./icons/SymbolsCloudOutline.vue');

var _SymbolsCloudOutline2 = _interopRequireDefault(_SymbolsCloudOutline);

var _SymbolsCopyFilled = require('./icons/SymbolsCopyFilled.vue');

var _SymbolsCopyFilled2 = _interopRequireDefault(_SymbolsCopyFilled);

var _SymbolsCopyOutline = require('./icons/SymbolsCopyOutline.vue');

var _SymbolsCopyOutline2 = _interopRequireDefault(_SymbolsCopyOutline);

var _SymbolsDarkFilled = require('./icons/SymbolsDarkFilled.vue');

var _SymbolsDarkFilled2 = _interopRequireDefault(_SymbolsDarkFilled);

var _SymbolsDarkOutline = require('./icons/SymbolsDarkOutline.vue');

var _SymbolsDarkOutline2 = _interopRequireDefault(_SymbolsDarkOutline);

var _SymbolsDropFilled = require('./icons/SymbolsDropFilled.vue');

var _SymbolsDropFilled2 = _interopRequireDefault(_SymbolsDropFilled);

var _SymbolsDropOutline = require('./icons/SymbolsDropOutline.vue');

var _SymbolsDropOutline2 = _interopRequireDefault(_SymbolsDropOutline);

var _SymbolsEditOutline = require('./icons/SymbolsEditOutline.vue');

var _SymbolsEditOutline2 = _interopRequireDefault(_SymbolsEditOutline);

var _SymbolsEyeFilled = require('./icons/SymbolsEyeFilled.vue');

var _SymbolsEyeFilled2 = _interopRequireDefault(_SymbolsEyeFilled);

var _SymbolsEyeOffFilled = require('./icons/SymbolsEyeOffFilled.vue');

var _SymbolsEyeOffFilled2 = _interopRequireDefault(_SymbolsEyeOffFilled);

var _SymbolsEyeOffOutline = require('./icons/SymbolsEyeOffOutline.vue');

var _SymbolsEyeOffOutline2 = _interopRequireDefault(_SymbolsEyeOffOutline);

var _SymbolsEyeOutline = require('./icons/SymbolsEyeOutline.vue');

var _SymbolsEyeOutline2 = _interopRequireDefault(_SymbolsEyeOutline);

var _SymbolsHeartFilled = require('./icons/SymbolsHeartFilled.vue');

var _SymbolsHeartFilled2 = _interopRequireDefault(_SymbolsHeartFilled);

var _SymbolsHeartOutline = require('./icons/SymbolsHeartOutline.vue');

var _SymbolsHeartOutline2 = _interopRequireDefault(_SymbolsHeartOutline);

var _SymbolsLightFilled = require('./icons/SymbolsLightFilled.vue');

var _SymbolsLightFilled2 = _interopRequireDefault(_SymbolsLightFilled);

var _SymbolsLightOutline = require('./icons/SymbolsLightOutline.vue');

var _SymbolsLightOutline2 = _interopRequireDefault(_SymbolsLightOutline);

var _SymbolsLikeFilled = require('./icons/SymbolsLikeFilled.vue');

var _SymbolsLikeFilled2 = _interopRequireDefault(_SymbolsLikeFilled);

var _SymbolsLikeOutline = require('./icons/SymbolsLikeOutline.vue');

var _SymbolsLikeOutline2 = _interopRequireDefault(_SymbolsLikeOutline);

var _SymbolsMinusOutline = require('./icons/SymbolsMinusOutline.vue');

var _SymbolsMinusOutline2 = _interopRequireDefault(_SymbolsMinusOutline);

var _SymbolsPaperPlaneRightFilled = require('./icons/SymbolsPaperPlaneRightFilled.vue');

var _SymbolsPaperPlaneRightFilled2 = _interopRequireDefault(_SymbolsPaperPlaneRightFilled);

var _SymbolsPaperPlaneRightOutline = require('./icons/SymbolsPaperPlaneRightOutline.vue');

var _SymbolsPaperPlaneRightOutline2 = _interopRequireDefault(_SymbolsPaperPlaneRightOutline);

var _SymbolsPaperPlaneTiltFilled = require('./icons/SymbolsPaperPlaneTiltFilled.vue');

var _SymbolsPaperPlaneTiltFilled2 = _interopRequireDefault(_SymbolsPaperPlaneTiltFilled);

var _SymbolsPaperPlaneTiltOutline = require('./icons/SymbolsPaperPlaneTiltOutline.vue');

var _SymbolsPaperPlaneTiltOutline2 = _interopRequireDefault(_SymbolsPaperPlaneTiltOutline);

var _SymbolsPercentageOutline = require('./icons/SymbolsPercentageOutline.vue');

var _SymbolsPercentageOutline2 = _interopRequireDefault(_SymbolsPercentageOutline);

var _SymbolsPieChartFilled = require('./icons/SymbolsPieChartFilled.vue');

var _SymbolsPieChartFilled2 = _interopRequireDefault(_SymbolsPieChartFilled);

var _SymbolsPieChartOutline = require('./icons/SymbolsPieChartOutline.vue');

var _SymbolsPieChartOutline2 = _interopRequireDefault(_SymbolsPieChartOutline);

var _SymbolsPlusFilled = require('./icons/SymbolsPlusFilled.vue');

var _SymbolsPlusFilled2 = _interopRequireDefault(_SymbolsPlusFilled);

var _SymbolsRadioButtonOutline = require('./icons/SymbolsRadioButtonOutline.vue');

var _SymbolsRadioButtonOutline2 = _interopRequireDefault(_SymbolsRadioButtonOutline);

var _SymbolsRadioButtonSelectedOutline = require('./icons/SymbolsRadioButtonSelectedOutline.vue');

var _SymbolsRadioButtonSelectedOutline2 = _interopRequireDefault(_SymbolsRadioButtonSelectedOutline);

var _SymbolsRectangle = require('./icons/SymbolsRectangle.vue');

var _SymbolsRectangle2 = _interopRequireDefault(_SymbolsRectangle);

var _SymbolsSquare = require('./icons/SymbolsSquare.vue');

var _SymbolsSquare2 = _interopRequireDefault(_SymbolsSquare);

var _SymbolsStarFilled = require('./icons/SymbolsStarFilled.vue');

var _SymbolsStarFilled2 = _interopRequireDefault(_SymbolsStarFilled);

var _SymbolsStarOutline = require('./icons/SymbolsStarOutline.vue');

var _SymbolsStarOutline2 = _interopRequireDefault(_SymbolsStarOutline);

var _SymbolsWidgetFilled = require('./icons/SymbolsWidgetFilled.vue');

var _SymbolsWidgetFilled2 = _interopRequireDefault(_SymbolsWidgetFilled);

var _SymbolsWidgetOutline = require('./icons/SymbolsWidgetOutline.vue');

var _SymbolsWidgetOutline2 = _interopRequireDefault(_SymbolsWidgetOutline);

var _SymbolsWifiOutline = require('./icons/SymbolsWifiOutline.vue');

var _SymbolsWifiOutline2 = _interopRequireDefault(_SymbolsWifiOutline);

var _SymbolsZoomInFilled = require('./icons/SymbolsZoomInFilled.vue');

var _SymbolsZoomInFilled2 = _interopRequireDefault(_SymbolsZoomInFilled);

var _SymbolsZoomInOutline = require('./icons/SymbolsZoomInOutline.vue');

var _SymbolsZoomInOutline2 = _interopRequireDefault(_SymbolsZoomInOutline);

var _SymbolsZoomOutFilled = require('./icons/SymbolsZoomOutFilled.vue');

var _SymbolsZoomOutFilled2 = _interopRequireDefault(_SymbolsZoomOutFilled);

var _SymbolsZoomOutOutline = require('./icons/SymbolsZoomOutOutline.vue');

var _SymbolsZoomOutOutline2 = _interopRequireDefault(_SymbolsZoomOutOutline);

var _SystemSystemTerminalFilled = require('./icons/SystemSystemTerminalFilled.vue');

var _SystemSystemTerminalFilled2 = _interopRequireDefault(_SystemSystemTerminalFilled);

var _UserPeopleFilled = require('./icons/UserPeopleFilled.vue');

var _UserPeopleFilled2 = _interopRequireDefault(_UserPeopleFilled);

var _UserPeopleOutline = require('./icons/UserPeopleOutline.vue');

var _UserPeopleOutline2 = _interopRequireDefault(_UserPeopleOutline);

var _UserPersonAddFilled = require('./icons/UserPersonAddFilled.vue');

var _UserPersonAddFilled2 = _interopRequireDefault(_UserPersonAddFilled);

var _UserPersonAddOutline = require('./icons/UserPersonAddOutline.vue');

var _UserPersonAddOutline2 = _interopRequireDefault(_UserPersonAddOutline);

var _UserPersonFilled = require('./icons/UserPersonFilled.vue');

var _UserPersonFilled2 = _interopRequireDefault(_UserPersonFilled);

var _UserPersonOutline = require('./icons/UserPersonOutline.vue');

var _UserPersonOutline2 = _interopRequireDefault(_UserPersonOutline);

var _WebSystemCarouselOutline = require('./icons/WebSystemCarouselOutline.vue');

var _WebSystemCarouselOutline2 = _interopRequireDefault(_WebSystemCarouselOutline);

var _WebSystemCode = require('./icons/WebSystemCode.vue');

var _WebSystemCode2 = _interopRequireDefault(_WebSystemCode);

var _WebSystemCommand = require('./icons/WebSystemCommand.vue');

var _WebSystemCommand2 = _interopRequireDefault(_WebSystemCommand);

var _WebSystemDashboardFilled = require('./icons/WebSystemDashboardFilled.vue');

var _WebSystemDashboardFilled2 = _interopRequireDefault(_WebSystemDashboardFilled);

var _WebSystemDashboardOutline = require('./icons/WebSystemDashboardOutline.vue');

var _WebSystemDashboardOutline2 = _interopRequireDefault(_WebSystemDashboardOutline);

var _WebSystemEnterOutline = require('./icons/WebSystemEnterOutline.vue');

var _WebSystemEnterOutline2 = _interopRequireDefault(_WebSystemEnterOutline);

var _WebSystemExitOutline = require('./icons/WebSystemExitOutline.vue');

var _WebSystemExitOutline2 = _interopRequireDefault(_WebSystemExitOutline);

var _WebSystemExternalOutline = require('./icons/WebSystemExternalOutline.vue');

var _WebSystemExternalOutline2 = _interopRequireDefault(_WebSystemExternalOutline);

var _WebSystemFaviconOutline = require('./icons/WebSystemFaviconOutline.vue');

var _WebSystemFaviconOutline2 = _interopRequireDefault(_WebSystemFaviconOutline);

var _WebSystemFormOutline = require('./icons/WebSystemFormOutline.vue');

var _WebSystemFormOutline2 = _interopRequireDefault(_WebSystemFormOutline);

var _WebSystemHierarchyOutline = require('./icons/WebSystemHierarchyOutline.vue');

var _WebSystemHierarchyOutline2 = _interopRequireDefault(_WebSystemHierarchyOutline);

var _WebSystemLinkHorizontalOutline = require('./icons/WebSystemLinkHorizontalOutline.vue');

var _WebSystemLinkHorizontalOutline2 = _interopRequireDefault(_WebSystemLinkHorizontalOutline);

var _WebSystemLinkOutline = require('./icons/WebSystemLinkOutline.vue');

var _WebSystemLinkOutline2 = _interopRequireDefault(_WebSystemLinkOutline);

var _WebSystemListOutline = require('./icons/WebSystemListOutline.vue');

var _WebSystemListOutline2 = _interopRequireDefault(_WebSystemListOutline);

var _WebSystemOption = require('./icons/WebSystemOption.vue');

var _WebSystemOption2 = _interopRequireDefault(_WebSystemOption);

var _WebSystemProgressCircleOutline = require('./icons/WebSystemProgressCircleOutline.vue');

var _WebSystemProgressCircleOutline2 = _interopRequireDefault(_WebSystemProgressCircleOutline);

var _WebSystemScaleOutline = require('./icons/WebSystemScaleOutline.vue');

var _WebSystemScaleOutline2 = _interopRequireDefault(_WebSystemScaleOutline);

var _WebSystemTerminalOutline = require('./icons/WebSystemTerminalOutline.vue');

var _WebSystemTerminalOutline2 = _interopRequireDefault(_WebSystemTerminalOutline);

var _WebSystemTouchOutline = require('./icons/WebSystemTouchOutline.vue');

var _WebSystemTouchOutline2 = _interopRequireDefault(_WebSystemTouchOutline);

var _WebSystemTrafficFilled = require('./icons/WebSystemTrafficFilled.vue');

var _WebSystemTrafficFilled2 = _interopRequireDefault(_WebSystemTrafficFilled);

var _WebSystemTrafficOutline = require('./icons/WebSystemTrafficOutline.vue');

var _WebSystemTrafficOutline2 = _interopRequireDefault(_WebSystemTrafficOutline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var arrowsArrowsOutOutline = exports.arrowsArrowsOutOutline = { name: 'arrows-arrows-out-outline', component: _ArrowsArrowsOutOutline2.default };
var arrowsBendUpLeft = exports.arrowsBendUpLeft = { name: 'arrows-bend-up-left', component: _ArrowsBendUpLeft2.default };
var arrowsBendUpRight = exports.arrowsBendUpRight = { name: 'arrows-bend-up-right', component: _ArrowsBendUpRight2.default };
var arrowsChevronDownFilled = exports.arrowsChevronDownFilled = { name: 'arrows-chevron-down-filled', component: _ArrowsChevronDownFilled2.default };
var arrowsChevronDownOutline = exports.arrowsChevronDownOutline = { name: 'arrows-chevron-down-outline', component: _ArrowsChevronDownOutline2.default };
var arrowsChevronLeftFilled = exports.arrowsChevronLeftFilled = { name: 'arrows-chevron-left-filled', component: _ArrowsChevronLeftFilled2.default };
var arrowsChevronLeftOutline = exports.arrowsChevronLeftOutline = { name: 'arrows-chevron-left-outline', component: _ArrowsChevronLeftOutline2.default };
var arrowsChevronRightFilled = exports.arrowsChevronRightFilled = { name: 'arrows-chevron-right-filled', component: _ArrowsChevronRightFilled2.default };
var arrowsChevronRightOutline = exports.arrowsChevronRightOutline = { name: 'arrows-chevron-right-outline', component: _ArrowsChevronRightOutline2.default };
var arrowsChevronUpAndDownOutline = exports.arrowsChevronUpAndDownOutline = { name: 'arrows-chevron-up-and-down-outline', component: _ArrowsChevronUpAndDownOutline2.default };
var arrowsChevronUpFilled = exports.arrowsChevronUpFilled = { name: 'arrows-chevron-up-filled', component: _ArrowsChevronUpFilled2.default };
var arrowsChevronUpOutline = exports.arrowsChevronUpOutline = { name: 'arrows-chevron-up-outline', component: _ArrowsChevronUpOutline2.default };
var arrowsCircleArrowDownFilled = exports.arrowsCircleArrowDownFilled = { name: 'arrows-circle-arrow-down-filled', component: _ArrowsCircleArrowDownFilled2.default };
var arrowsCircleArrowDownOutline = exports.arrowsCircleArrowDownOutline = { name: 'arrows-circle-arrow-down-outline', component: _ArrowsCircleArrowDownOutline2.default };
var arrowsCircleArrowLeftFilled = exports.arrowsCircleArrowLeftFilled = { name: 'arrows-circle-arrow-left-filled', component: _ArrowsCircleArrowLeftFilled2.default };
var arrowsCircleArrowLeftOutline = exports.arrowsCircleArrowLeftOutline = { name: 'arrows-circle-arrow-left-outline', component: _ArrowsCircleArrowLeftOutline2.default };
var arrowsCircleArrowRightFilled = exports.arrowsCircleArrowRightFilled = { name: 'arrows-circle-arrow-right-filled', component: _ArrowsCircleArrowRightFilled2.default };
var arrowsCircleArrowRightOutline = exports.arrowsCircleArrowRightOutline = { name: 'arrows-circle-arrow-right-outline', component: _ArrowsCircleArrowRightOutline2.default };
var arrowsCircleArrowUpFilled = exports.arrowsCircleArrowUpFilled = { name: 'arrows-circle-arrow-up-filled', component: _ArrowsCircleArrowUpFilled2.default };
var arrowsCircleArrowUpOutline = exports.arrowsCircleArrowUpOutline = { name: 'arrows-circle-arrow-up-outline', component: _ArrowsCircleArrowUpOutline2.default };
var arrowsClockwise = exports.arrowsClockwise = { name: 'arrows-clockwise', component: _ArrowsClockwise2.default };
var arrowsCounterClockwise = exports.arrowsCounterClockwise = { name: 'arrows-counter-clockwise', component: _ArrowsCounterClockwise2.default };
var arrowsCycleCheckOutline = exports.arrowsCycleCheckOutline = { name: 'arrows-cycle-check-outline', component: _ArrowsCycleCheckOutline2.default };
var arrowsDownOutline = exports.arrowsDownOutline = { name: 'arrows-down-outline', component: _ArrowsDownOutline2.default };
var arrowsFatDownFilled = exports.arrowsFatDownFilled = { name: 'arrows-fat-down-filled', component: _ArrowsFatDownFilled2.default };
var arrowsFatDownOutline = exports.arrowsFatDownOutline = { name: 'arrows-fat-down-outline', component: _ArrowsFatDownOutline2.default };
var arrowsFatLeftFilled = exports.arrowsFatLeftFilled = { name: 'arrows-fat-left-filled', component: _ArrowsFatLeftFilled2.default };
var arrowsFatLeftOutline = exports.arrowsFatLeftOutline = { name: 'arrows-fat-left-outline', component: _ArrowsFatLeftOutline2.default };
var arrowsFatLineDownFilled = exports.arrowsFatLineDownFilled = { name: 'arrows-fat-line-down-filled', component: _ArrowsFatLineDownFilled2.default };
var arrowsFatLineDownOutline = exports.arrowsFatLineDownOutline = { name: 'arrows-fat-line-down-outline', component: _ArrowsFatLineDownOutline2.default };
var arrowsFatLineLeftFilled = exports.arrowsFatLineLeftFilled = { name: 'arrows-fat-line-left-filled', component: _ArrowsFatLineLeftFilled2.default };
var arrowsFatLineLeftOutline = exports.arrowsFatLineLeftOutline = { name: 'arrows-fat-line-left-outline', component: _ArrowsFatLineLeftOutline2.default };
var arrowsFatLineRightFilled = exports.arrowsFatLineRightFilled = { name: 'arrows-fat-line-right-filled', component: _ArrowsFatLineRightFilled2.default };
var arrowsFatLineRightOutline = exports.arrowsFatLineRightOutline = { name: 'arrows-fat-line-right-outline', component: _ArrowsFatLineRightOutline2.default };
var arrowsFatLineUpFilled = exports.arrowsFatLineUpFilled = { name: 'arrows-fat-line-up-filled', component: _ArrowsFatLineUpFilled2.default };
var arrowsFatLineUpOutline = exports.arrowsFatLineUpOutline = { name: 'arrows-fat-line-up-outline', component: _ArrowsFatLineUpOutline2.default };
var arrowsFatRightFilled = exports.arrowsFatRightFilled = { name: 'arrows-fat-right-filled', component: _ArrowsFatRightFilled2.default };
var arrowsFatRightOutline = exports.arrowsFatRightOutline = { name: 'arrows-fat-right-outline', component: _ArrowsFatRightOutline2.default };
var arrowsFatUpFilled = exports.arrowsFatUpFilled = { name: 'arrows-fat-up-filled', component: _ArrowsFatUpFilled2.default };
var arrowsFatUpOutline = exports.arrowsFatUpOutline = { name: 'arrows-fat-up-outline', component: _ArrowsFatUpOutline2.default };
var arrowsHorizontalOutline = exports.arrowsHorizontalOutline = { name: 'arrows-horizontal-outline', component: _ArrowsHorizontalOutline2.default };
var arrowsLeftAndRightOutline = exports.arrowsLeftAndRightOutline = { name: 'arrows-left-and-right-outline', component: _ArrowsLeftAndRightOutline2.default };
var arrowsLeftDown = exports.arrowsLeftDown = { name: 'arrows-left-down', component: _ArrowsLeftDown2.default };
var arrowsLeftOutline = exports.arrowsLeftOutline = { name: 'arrows-left-outline', component: _ArrowsLeftOutline2.default };
var arrowsOutCardinalOutline = exports.arrowsOutCardinalOutline = { name: 'arrows-out-cardinal-outline', component: _ArrowsOutCardinalOutline2.default };
var arrowsRightOutline = exports.arrowsRightOutline = { name: 'arrows-right-outline', component: _ArrowsRightOutline2.default };
var arrowsShrinkOutline = exports.arrowsShrinkOutline = { name: 'arrows-shrink-outline', component: _ArrowsShrinkOutline2.default };
var arrowsUpOutline = exports.arrowsUpOutline = { name: 'arrows-up-outline', component: _ArrowsUpOutline2.default };
var arrowsVerticalOutline = exports.arrowsVerticalOutline = { name: 'arrows-vertical-outline', component: _ArrowsVerticalOutline2.default };
var brandAllin = exports.brandAllin = { name: 'brand-allin', component: _BrandAllin2.default };
var brandAmericanExpress = exports.brandAmericanExpress = { name: 'brand-american-express', component: _BrandAmericanExpress2.default };
var brandAndroidFilled = exports.brandAndroidFilled = { name: 'brand-android-filled', component: _BrandAndroidFilled2.default };
var brandAppleFilled = exports.brandAppleFilled = { name: 'brand-apple-filled', component: _BrandAppleFilled2.default };
var brandBitbucketFilled = exports.brandBitbucketFilled = { name: 'brand-bitbucket-filled', component: _BrandBitbucketFilled2.default };
var brandCentosFilled = exports.brandCentosFilled = { name: 'brand-centos-filled', component: _BrandCentosFilled2.default };
var brandCplug = exports.brandCplug = { name: 'brand-cplug', component: _BrandCplug2.default };
var brandCredisfera = exports.brandCredisfera = { name: 'brand-credisfera', component: _BrandCredisfera2.default };
var brandCronospainel = exports.brandCronospainel = { name: 'brand-cronospainel', component: _BrandCronospainel2.default };
var brandDebianFilled = exports.brandDebianFilled = { name: 'brand-debian-filled', component: _BrandDebianFilled2.default };
var brandDeliveryDireto = exports.brandDeliveryDireto = { name: 'brand-delivery-direto', component: _BrandDeliveryDireto2.default };
var brandDesk360 = exports.brandDesk360 = { name: 'brand-desk360', component: _BrandDesk2.default };
var brandDinersClub = exports.brandDinersClub = { name: 'brand-diners-club', component: _BrandDinersClub2.default };
var brandDooca = exports.brandDooca = { name: 'brand-dooca', component: _BrandDooca2.default };
var brandDrupalFilled = exports.brandDrupalFilled = { name: 'brand-drupal-filled', component: _BrandDrupalFilled2.default };
var brandEloFilled = exports.brandEloFilled = { name: 'brand-elo-filled', component: _BrandEloFilled2.default };
var brandEtus = exports.brandEtus = { name: 'brand-etus', component: _BrandEtus2.default };
var brandFacebookFilled = exports.brandFacebookFilled = { name: 'brand-facebook-filled', component: _BrandFacebookFilled2.default };
var brandFedoraFilled = exports.brandFedoraFilled = { name: 'brand-fedora-filled', component: _BrandFedoraFilled2.default };
var brandFilezillaFilled = exports.brandFilezillaFilled = { name: 'brand-filezilla-filled', component: _BrandFilezillaFilled2.default };
var brandFirebaseFilled = exports.brandFirebaseFilled = { name: 'brand-firebase-filled', component: _BrandFirebaseFilled2.default };
var brandGitFilled = exports.brandGitFilled = { name: 'brand-git-filled', component: _BrandGitFilled2.default };
var brandGithubFilled = exports.brandGithubFilled = { name: 'brand-github-filled', component: _BrandGithubFilled2.default };
var brandGitlabFilled = exports.brandGitlabFilled = { name: 'brand-gitlab-filled', component: _BrandGitlabFilled2.default };
var brandGoogleAnalyticsFilled = exports.brandGoogleAnalyticsFilled = { name: 'brand-google-analytics-filled', component: _BrandGoogleAnalyticsFilled2.default };
var brandIderis = exports.brandIderis = { name: 'brand-ideris', component: _BrandIderis2.default };
var brandInstagramFilled = exports.brandInstagramFilled = { name: 'brand-instagram-filled', component: _BrandInstagramFilled2.default };
var brandJoomlaFilled = exports.brandJoomlaFilled = { name: 'brand-joomla-filled', component: _BrandJoomlaFilled2.default };
var brandLampFilled = exports.brandLampFilled = { name: 'brand-lamp-filled', component: _BrandLampFilled2.default };
var brandLinuxFilled = exports.brandLinuxFilled = { name: 'brand-linux-filled', component: _BrandLinuxFilled2.default };
var brandLocawebFilled = exports.brandLocawebFilled = { name: 'brand-locaweb-filled', component: _BrandLocawebFilled2.default };
var brandMariadbFilled = exports.brandMariadbFilled = { name: 'brand-mariadb-filled', component: _BrandMariadbFilled2.default };
var brandMastercardFilled = exports.brandMastercardFilled = { name: 'brand-mastercard-filled', component: _BrandMastercardFilled2.default };
var brandMastercardSymbolFilled = exports.brandMastercardSymbolFilled = { name: 'brand-mastercard-symbol-filled', component: _BrandMastercardSymbolFilled2.default };
var brandMelhorenvio = exports.brandMelhorenvio = { name: 'brand-melhorenvio', component: _BrandMelhorenvio2.default };
var brandMicrosoftFilled = exports.brandMicrosoftFilled = { name: 'brand-microsoft-filled', component: _BrandMicrosoftFilled2.default };
var brandMicrosoftsqlserverSymbolFilled = exports.brandMicrosoftsqlserverSymbolFilled = { name: 'brand-microsoftsqlserver-symbol-filled', component: _BrandMicrosoftsqlserverSymbolFilled2.default };
var brandMongodbFilled = exports.brandMongodbFilled = { name: 'brand-mongodb-filled', component: _BrandMongodbFilled2.default };
var brandMysqlFilled = exports.brandMysqlFilled = { name: 'brand-mysql-filled', component: _BrandMysqlFilled2.default };
var brandMysqlOutline = exports.brandMysqlOutline = { name: 'brand-mysql-outline', component: _BrandMysqlOutline2.default };
var brandNextios = exports.brandNextios = { name: 'brand-nextios', component: _BrandNextios2.default };
var brandNginxFilled = exports.brandNginxFilled = { name: 'brand-nginx-filled', component: _BrandNginxFilled2.default };
var brandNodejsFilled = exports.brandNodejsFilled = { name: 'brand-nodejs-filled', component: _BrandNodejsFilled2.default };
var brandOpensuseFilled = exports.brandOpensuseFilled = { name: 'brand-opensuse-filled', component: _BrandOpensuseFilled2.default };
var brandOutlookOutline = exports.brandOutlookOutline = { name: 'brand-outlook-outline', component: _BrandOutlookOutline2.default };
var brandPhpFilled = exports.brandPhpFilled = { name: 'brand-php-filled', component: _BrandPhpFilled2.default };
var brandPhpmyadminFilled = exports.brandPhpmyadminFilled = { name: 'brand-phpmyadmin-filled', component: _BrandPhpmyadminFilled2.default };
var brandPixFilled = exports.brandPixFilled = { name: 'brand-pix-filled', component: _BrandPixFilled2.default };
var brandPostgresqlFilled = exports.brandPostgresqlFilled = { name: 'brand-postgresql-filled', component: _BrandPostgresqlFilled2.default };
var brandRedisFilled = exports.brandRedisFilled = { name: 'brand-redis-filled', component: _BrandRedisFilled2.default };
var brandSamuraiExperts = exports.brandSamuraiExperts = { name: 'brand-samurai-experts', component: _BrandSamuraiExperts2.default };
var brandSocialminer = exports.brandSocialminer = { name: 'brand-socialminer', component: _BrandSocialminer2.default };
var brandSourceforgeFilled = exports.brandSourceforgeFilled = { name: 'brand-sourceforge-filled', component: _BrandSourceforgeFilled2.default };
var brandSugarcrmFilled = exports.brandSugarcrmFilled = { name: 'brand-sugarcrm-filled', component: _BrandSugarcrmFilled2.default };
var brandTelegramFilled = exports.brandTelegramFilled = { name: 'brand-telegram-filled', component: _BrandTelegramFilled2.default };
var brandThunderbirdFilled = exports.brandThunderbirdFilled = { name: 'brand-thunderbird-filled', component: _BrandThunderbirdFilled2.default };
var brandTray = exports.brandTray = { name: 'brand-tray', component: _BrandTray2.default };
var brandUbuntuFilled = exports.brandUbuntuFilled = { name: 'brand-ubuntu-filled', component: _BrandUbuntuFilled2.default };
var brandVindi = exports.brandVindi = { name: 'brand-vindi', component: _BrandVindi2.default };
var brandVisaFilled = exports.brandVisaFilled = { name: 'brand-visa-filled', component: _BrandVisaFilled2.default };
var brandWhatsappFilled = exports.brandWhatsappFilled = { name: 'brand-whatsapp-filled', component: _BrandWhatsappFilled2.default };
var brandWindowsFilled = exports.brandWindowsFilled = { name: 'brand-windows-filled', component: _BrandWindowsFilled2.default };
var brandWoocommerceFilled = exports.brandWoocommerceFilled = { name: 'brand-woocommerce-filled', component: _BrandWoocommerceFilled2.default };
var brandWordpressFilled = exports.brandWordpressFilled = { name: 'brand-wordpress-filled', component: _BrandWordpressFilled2.default };
var brandYapay = exports.brandYapay = { name: 'brand-yapay', component: _BrandYapay2.default };
var brandZenphotoFilled = exports.brandZenphotoFilled = { name: 'brand-zenphoto-filled', component: _BrandZenphotoFilled2.default };
var communicationChatAlertFilled = exports.communicationChatAlertFilled = { name: 'communication-chat-alert-filled', component: _CommunicationChatAlertFilled2.default };
var communicationChatAlertOutline = exports.communicationChatAlertOutline = { name: 'communication-chat-alert-outline', component: _CommunicationChatAlertOutline2.default };
var communicationChatFilled = exports.communicationChatFilled = { name: 'communication-chat-filled', component: _CommunicationChatFilled2.default };
var communicationChatOffFilled = exports.communicationChatOffFilled = { name: 'communication-chat-off-filled', component: _CommunicationChatOffFilled2.default };
var communicationChatOffOutline = exports.communicationChatOffOutline = { name: 'communication-chat-off-outline', component: _CommunicationChatOffOutline2.default };
var communicationChatOutline = exports.communicationChatOutline = { name: 'communication-chat-outline', component: _CommunicationChatOutline2.default };
var communicationHelpChatFilled = exports.communicationHelpChatFilled = { name: 'communication-help-chat-filled', component: _CommunicationHelpChatFilled2.default };
var communicationHelpChatOutline = exports.communicationHelpChatOutline = { name: 'communication-help-chat-outline', component: _CommunicationHelpChatOutline2.default };
var communicationQuoteFilled = exports.communicationQuoteFilled = { name: 'communication-quote-filled', component: _CommunicationQuoteFilled2.default };
var communicationQuoteOutline = exports.communicationQuoteOutline = { name: 'communication-quote-outline', component: _CommunicationQuoteOutline2.default };
var devicesScreenOutline = exports.devicesScreenOutline = { name: 'devices-screen-outline', component: _DevicesScreenOutline2.default };
var devicesSmartphoneOutline = exports.devicesSmartphoneOutline = { name: 'devices-smartphone-outline', component: _DevicesSmartphoneOutline2.default };
var devicesTabletOutline = exports.devicesTabletOutline = { name: 'devices-tablet-outline', component: _DevicesTabletOutline2.default };
var dotsNine = exports.dotsNine = { name: 'dots-nine', component: _DotsNine2.default };
var dotsOne = exports.dotsOne = { name: 'dots-one', component: _DotsOne2.default };
var dotsSixHorizontal = exports.dotsSixHorizontal = { name: 'dots-six-horizontal', component: _DotsSixHorizontal2.default };
var dotsSixVertical = exports.dotsSixVertical = { name: 'dots-six-vertical', component: _DotsSixVertical2.default };
var dotsThreeHorizontal = exports.dotsThreeHorizontal = { name: 'dots-three-horizontal', component: _DotsThreeHorizontal2.default };
var dotsThreeVertical = exports.dotsThreeVertical = { name: 'dots-three-vertical', component: _DotsThreeVertical2.default };
var editorTableOutline = exports.editorTableOutline = { name: 'editor-table-outline', component: _EditorTableOutline2.default };
var editorTextAlignCenter = exports.editorTextAlignCenter = { name: 'editor-text-align-center', component: _EditorTextAlignCenter2.default };
var editorTextAlignJustify = exports.editorTextAlignJustify = { name: 'editor-text-align-justify', component: _EditorTextAlignJustify2.default };
var editorTextAlignLeft = exports.editorTextAlignLeft = { name: 'editor-text-align-left', component: _EditorTextAlignLeft2.default };
var editorTextAlignRight = exports.editorTextAlignRight = { name: 'editor-text-align-right', component: _EditorTextAlignRight2.default };
var editorTextBoldOutline = exports.editorTextBoldOutline = { name: 'editor-text-bold-outline', component: _EditorTextBoldOutline2.default };
var editorTextItalicOutline = exports.editorTextItalicOutline = { name: 'editor-text-italic-outline', component: _EditorTextItalicOutline2.default };
var editorTitleOutline = exports.editorTitleOutline = { name: 'editor-title-outline', component: _EditorTitleOutline2.default };
var emoteHappyFilled = exports.emoteHappyFilled = { name: 'emote-happy-filled', component: _EmoteHappyFilled2.default };
var emoteHappyOutline = exports.emoteHappyOutline = { name: 'emote-happy-outline', component: _EmoteHappyOutline2.default };
var emoteSadFilled = exports.emoteSadFilled = { name: 'emote-sad-filled', component: _EmoteSadFilled2.default };
var emoteSadOutline = exports.emoteSadOutline = { name: 'emote-sad-outline', component: _EmoteSadOutline2.default };
var filesCheckFilled = exports.filesCheckFilled = { name: 'files-check-filled', component: _FilesCheckFilled2.default };
var filesCheckOutline = exports.filesCheckOutline = { name: 'files-check-outline', component: _FilesCheckOutline2.default };
var filesCloseFilled = exports.filesCloseFilled = { name: 'files-close-filled', component: _FilesCloseFilled2.default };
var filesCloseOutline = exports.filesCloseOutline = { name: 'files-close-outline', component: _FilesCloseOutline2.default };
var filesFile = exports.filesFile = { name: 'files-file', component: _FilesFile2.default };
var filesHistoryFilled = exports.filesHistoryFilled = { name: 'files-history-filled', component: _FilesHistoryFilled2.default };
var filesHistoryOutline = exports.filesHistoryOutline = { name: 'files-history-outline', component: _FilesHistoryOutline2.default };
var filesMinusFilled = exports.filesMinusFilled = { name: 'files-minus-filled', component: _FilesMinusFilled2.default };
var filesMinusOutline = exports.filesMinusOutline = { name: 'files-minus-outline', component: _FilesMinusOutline2.default };
var filesPlusFilled = exports.filesPlusFilled = { name: 'files-plus-filled', component: _FilesPlusFilled2.default };
var filesPlusOutline = exports.filesPlusOutline = { name: 'files-plus-outline', component: _FilesPlusOutline2.default };
var filesReportsOutline = exports.filesReportsOutline = { name: 'files-reports-outline', component: _FilesReportsOutline2.default };
var filesSearchFilled = exports.filesSearchFilled = { name: 'files-search-filled', component: _FilesSearchFilled2.default };
var filesSearchOutline = exports.filesSearchOutline = { name: 'files-search-outline', component: _FilesSearchOutline2.default };
var filesStatementFilled = exports.filesStatementFilled = { name: 'files-statement-filled', component: _FilesStatementFilled2.default };
var filesStatementOutline = exports.filesStatementOutline = { name: 'files-statement-outline', component: _FilesStatementOutline2.default };
var filesTextFileFilled = exports.filesTextFileFilled = { name: 'files-text-file-filled', component: _FilesTextFileFilled2.default };
var filesTextFileOutline = exports.filesTextFileOutline = { name: 'files-text-file-outline', component: _FilesTextFileOutline2.default };
var financeCashFilled = exports.financeCashFilled = { name: 'finance-cash-filled', component: _FinanceCashFilled2.default };
var financeCashOutline = exports.financeCashOutline = { name: 'finance-cash-outline', component: _FinanceCashOutline2.default };
var financeCircleDollarSignFilled = exports.financeCircleDollarSignFilled = { name: 'finance-circle-dollar-sign-filled', component: _FinanceCircleDollarSignFilled2.default };
var financeCircleDollarSignOutline = exports.financeCircleDollarSignOutline = { name: 'finance-circle-dollar-sign-outline', component: _FinanceCircleDollarSignOutline2.default };
var financeCreditCardFilled = exports.financeCreditCardFilled = { name: 'finance-credit-card-filled', component: _FinanceCreditCardFilled2.default };
var financeCreditCardOutline = exports.financeCreditCardOutline = { name: 'finance-credit-card-outline', component: _FinanceCreditCardOutline2.default };
var financeCreditCardsFilled = exports.financeCreditCardsFilled = { name: 'finance-credit-cards-filled', component: _FinanceCreditCardsFilled2.default };
var financeCreditCardsOutline = exports.financeCreditCardsOutline = { name: 'finance-credit-cards-outline', component: _FinanceCreditCardsOutline2.default };
var financeDollarSignOffOutline = exports.financeDollarSignOffOutline = { name: 'finance-dollar-sign-off-outline', component: _FinanceDollarSignOffOutline2.default };
var financeDollarSignOutline = exports.financeDollarSignOutline = { name: 'finance-dollar-sign-outline', component: _FinanceDollarSignOutline2.default };
var hardwareCpuFilled = exports.hardwareCpuFilled = { name: 'hardware-cpu-filled', component: _HardwareCpuFilled2.default };
var hardwareCpuOutline = exports.hardwareCpuOutline = { name: 'hardware-cpu-outline', component: _HardwareCpuOutline2.default };
var hardwareHddFilled = exports.hardwareHddFilled = { name: 'hardware-hdd-filled', component: _HardwareHddFilled2.default };
var hardwareHddOutline = exports.hardwareHddOutline = { name: 'hardware-hdd-outline', component: _HardwareHddOutline2.default };
var hardwareMemoryFilled = exports.hardwareMemoryFilled = { name: 'hardware-memory-filled', component: _HardwareMemoryFilled2.default };
var hardwareMemoryOutline = exports.hardwareMemoryOutline = { name: 'hardware-memory-outline', component: _HardwareMemoryOutline2.default };
var hardwareSsdFilled = exports.hardwareSsdFilled = { name: 'hardware-ssd-filled', component: _HardwareSsdFilled2.default };
var hardwareSsdOutline = exports.hardwareSsdOutline = { name: 'hardware-ssd-outline', component: _HardwareSsdOutline2.default };
var localizationGlobeFilled = exports.localizationGlobeFilled = { name: 'localization-globe-filled', component: _LocalizationGlobeFilled2.default };
var localizationGlobeOutline = exports.localizationGlobeOutline = { name: 'localization-globe-outline', component: _LocalizationGlobeOutline2.default };
var localizationGlobePinnedFilled = exports.localizationGlobePinnedFilled = { name: 'localization-globe-pinned-filled', component: _LocalizationGlobePinnedFilled2.default };
var localizationGlobePinnedOutline = exports.localizationGlobePinnedOutline = { name: 'localization-globe-pinned-outline', component: _LocalizationGlobePinnedOutline2.default };
var localizationGlobePlusFilled = exports.localizationGlobePlusFilled = { name: 'localization-globe-plus-filled', component: _LocalizationGlobePlusFilled2.default };
var localizationGlobePlusOutline = exports.localizationGlobePlusOutline = { name: 'localization-globe-plus-outline', component: _LocalizationGlobePlusOutline2.default };
var localizationPinFilled = exports.localizationPinFilled = { name: 'localization-pin-filled', component: _LocalizationPinFilled2.default };
var localizationPinOutline = exports.localizationPinOutline = { name: 'localization-pin-outline', component: _LocalizationPinOutline2.default };
var mediaImageExpandedFilled = exports.mediaImageExpandedFilled = { name: 'media-image-expanded-filled', component: _MediaImageExpandedFilled2.default };
var mediaImageExpandedOutline = exports.mediaImageExpandedOutline = { name: 'media-image-expanded-outline', component: _MediaImageExpandedOutline2.default };
var mediaImageFilled = exports.mediaImageFilled = { name: 'media-image-filled', component: _MediaImageFilled2.default };
var mediaImageOutline = exports.mediaImageOutline = { name: 'media-image-outline', component: _MediaImageOutline2.default };
var mediaPauseFilled = exports.mediaPauseFilled = { name: 'media-pause-filled', component: _MediaPauseFilled2.default };
var mediaPauseOutline = exports.mediaPauseOutline = { name: 'media-pause-outline', component: _MediaPauseOutline2.default };
var mediaPlayFilled = exports.mediaPlayFilled = { name: 'media-play-filled', component: _MediaPlayFilled2.default };
var mediaPlayOutline = exports.mediaPlayOutline = { name: 'media-play-outline', component: _MediaPlayOutline2.default };
var mediaVolumeOffFilled = exports.mediaVolumeOffFilled = { name: 'media-volume-off-filled', component: _MediaVolumeOffFilled2.default };
var mediaVolumeOffOutline = exports.mediaVolumeOffOutline = { name: 'media-volume-off-outline', component: _MediaVolumeOffOutline2.default };
var mediaVolumeOnFilled = exports.mediaVolumeOnFilled = { name: 'media-volume-on-filled', component: _MediaVolumeOnFilled2.default };
var mediaVolumeOnOutline = exports.mediaVolumeOnOutline = { name: 'media-volume-on-outline', component: _MediaVolumeOnOutline2.default };
var objectsBalanceFilled = exports.objectsBalanceFilled = { name: 'objects-balance-filled', component: _ObjectsBalanceFilled2.default };
var objectsBalanceOutline = exports.objectsBalanceOutline = { name: 'objects-balance-outline', component: _ObjectsBalanceOutline2.default };
var objectsBellFilled = exports.objectsBellFilled = { name: 'objects-bell-filled', component: _ObjectsBellFilled2.default };
var objectsBellOffFilled = exports.objectsBellOffFilled = { name: 'objects-bell-off-filled', component: _ObjectsBellOffFilled2.default };
var objectsBellOffOutline = exports.objectsBellOffOutline = { name: 'objects-bell-off-outline', component: _ObjectsBellOffOutline2.default };
var objectsBellOutline = exports.objectsBellOutline = { name: 'objects-bell-outline', component: _ObjectsBellOutline2.default };
var objectsBoxFilled = exports.objectsBoxFilled = { name: 'objects-box-filled', component: _ObjectsBoxFilled2.default };
var objectsBoxOutline = exports.objectsBoxOutline = { name: 'objects-box-outline', component: _ObjectsBoxOutline2.default };
var objectsCalculatorFilled = exports.objectsCalculatorFilled = { name: 'objects-calculator-filled', component: _ObjectsCalculatorFilled2.default };
var objectsCalculatorOutline = exports.objectsCalculatorOutline = { name: 'objects-calculator-outline', component: _ObjectsCalculatorOutline2.default };
var objectsCalendarFilled = exports.objectsCalendarFilled = { name: 'objects-calendar-filled', component: _ObjectsCalendarFilled2.default };
var objectsCalendarOutline = exports.objectsCalendarOutline = { name: 'objects-calendar-outline', component: _ObjectsCalendarOutline2.default };
var objectsCameraFilled = exports.objectsCameraFilled = { name: 'objects-camera-filled', component: _ObjectsCameraFilled2.default };
var objectsCameraOutline = exports.objectsCameraOutline = { name: 'objects-camera-outline', component: _ObjectsCameraOutline2.default };
var objectsCdFilled = exports.objectsCdFilled = { name: 'objects-cd-filled', component: _ObjectsCdFilled2.default };
var objectsCdOutline = exports.objectsCdOutline = { name: 'objects-cd-outline', component: _ObjectsCdOutline2.default };
var objectsClockFilled = exports.objectsClockFilled = { name: 'objects-clock-filled', component: _ObjectsClockFilled2.default };
var objectsClockOutline = exports.objectsClockOutline = { name: 'objects-clock-outline', component: _ObjectsClockOutline2.default };
var objectsCompassOutline = exports.objectsCompassOutline = { name: 'objects-compass-outline', component: _ObjectsCompassOutline2.default };
var objectsEraserOutline = exports.objectsEraserOutline = { name: 'objects-eraser-outline', component: _ObjectsEraserOutline2.default };
var objectsFloppyDiskFilled = exports.objectsFloppyDiskFilled = { name: 'objects-floppy-disk-filled', component: _ObjectsFloppyDiskFilled2.default };
var objectsFloppyDiskOutline = exports.objectsFloppyDiskOutline = { name: 'objects-floppy-disk-outline', component: _ObjectsFloppyDiskOutline2.default };
var objectsFolderFilled = exports.objectsFolderFilled = { name: 'objects-folder-filled', component: _ObjectsFolderFilled2.default };
var objectsFolderOutline = exports.objectsFolderOutline = { name: 'objects-folder-outline', component: _ObjectsFolderOutline2.default };
var objectsFunnelFilled = exports.objectsFunnelFilled = { name: 'objects-funnel-filled', component: _ObjectsFunnelFilled2.default };
var objectsFunnelOutline = exports.objectsFunnelOutline = { name: 'objects-funnel-outline', component: _ObjectsFunnelOutline2.default };
var objectsGearFilled = exports.objectsGearFilled = { name: 'objects-gear-filled', component: _ObjectsGearFilled2.default };
var objectsGearOutline = exports.objectsGearOutline = { name: 'objects-gear-outline', component: _ObjectsGearOutline2.default };
var objectsGiftOutline = exports.objectsGiftOutline = { name: 'objects-gift-outline', component: _ObjectsGiftOutline2.default };
var objectsHeadphoneFilled = exports.objectsHeadphoneFilled = { name: 'objects-headphone-filled', component: _ObjectsHeadphoneFilled2.default };
var objectsHeadphoneOutline = exports.objectsHeadphoneOutline = { name: 'objects-headphone-outline', component: _ObjectsHeadphoneOutline2.default };
var objectsKeyOutline = exports.objectsKeyOutline = { name: 'objects-key-outline', component: _ObjectsKeyOutline2.default };
var objectsLampFilled = exports.objectsLampFilled = { name: 'objects-lamp-filled', component: _ObjectsLampFilled2.default };
var objectsLampOnFilled = exports.objectsLampOnFilled = { name: 'objects-lamp-on-filled', component: _ObjectsLampOnFilled2.default };
var objectsLampOnOutline = exports.objectsLampOnOutline = { name: 'objects-lamp-on-outline', component: _ObjectsLampOnOutline2.default };
var objectsLampOutline = exports.objectsLampOutline = { name: 'objects-lamp-outline', component: _ObjectsLampOutline2.default };
var objectsLockFilled = exports.objectsLockFilled = { name: 'objects-lock-filled', component: _ObjectsLockFilled2.default };
var objectsLockOpenFilled = exports.objectsLockOpenFilled = { name: 'objects-lock-open-filled', component: _ObjectsLockOpenFilled2.default };
var objectsLockOpenOutline = exports.objectsLockOpenOutline = { name: 'objects-lock-open-outline', component: _ObjectsLockOpenOutline2.default };
var objectsLockOutline = exports.objectsLockOutline = { name: 'objects-lock-outline', component: _ObjectsLockOutline2.default };
var objectsMagnifyOutline = exports.objectsMagnifyOutline = { name: 'objects-magnify-outline', component: _ObjectsMagnifyOutline2.default };
var objectsMailFilled = exports.objectsMailFilled = { name: 'objects-mail-filled', component: _ObjectsMailFilled2.default };
var objectsMailOpenFilled = exports.objectsMailOpenFilled = { name: 'objects-mail-open-filled', component: _ObjectsMailOpenFilled2.default };
var objectsMailOpenOutline = exports.objectsMailOpenOutline = { name: 'objects-mail-open-outline', component: _ObjectsMailOpenOutline2.default };
var objectsMailOutline = exports.objectsMailOutline = { name: 'objects-mail-outline', component: _ObjectsMailOutline2.default };
var objectsMegaphoneOutline = exports.objectsMegaphoneOutline = { name: 'objects-megaphone-outline', component: _ObjectsMegaphoneOutline2.default };
var objectsMicrophoneFilled = exports.objectsMicrophoneFilled = { name: 'objects-microphone-filled', component: _ObjectsMicrophoneFilled2.default };
var objectsMicrophoneOutline = exports.objectsMicrophoneOutline = { name: 'objects-microphone-outline', component: _ObjectsMicrophoneOutline2.default };
var objectsPaintBucketFilled = exports.objectsPaintBucketFilled = { name: 'objects-paint-bucket-filled', component: _ObjectsPaintBucketFilled2.default };
var objectsPaintBucketOutline = exports.objectsPaintBucketOutline = { name: 'objects-paint-bucket-outline', component: _ObjectsPaintBucketOutline2.default };
var objectsPaperclipOutline = exports.objectsPaperclipOutline = { name: 'objects-paperclip-outline', component: _ObjectsPaperclipOutline2.default };
var objectsPencilFilled = exports.objectsPencilFilled = { name: 'objects-pencil-filled', component: _ObjectsPencilFilled2.default };
var objectsPencilOutline = exports.objectsPencilOutline = { name: 'objects-pencil-outline', component: _ObjectsPencilOutline2.default };
var objectsPhoneFilled = exports.objectsPhoneFilled = { name: 'objects-phone-filled', component: _ObjectsPhoneFilled2.default };
var objectsPhoneOutline = exports.objectsPhoneOutline = { name: 'objects-phone-outline', component: _ObjectsPhoneOutline2.default };
var objectsPickerOutline = exports.objectsPickerOutline = { name: 'objects-picker-outline', component: _ObjectsPickerOutline2.default };
var objectsPrinterFilled = exports.objectsPrinterFilled = { name: 'objects-printer-filled', component: _ObjectsPrinterFilled2.default };
var objectsPrinterOutline = exports.objectsPrinterOutline = { name: 'objects-printer-outline', component: _ObjectsPrinterOutline2.default };
var objectsPuzzleFilled = exports.objectsPuzzleFilled = { name: 'objects-puzzle-filled', component: _ObjectsPuzzleFilled2.default };
var objectsPuzzleOutline = exports.objectsPuzzleOutline = { name: 'objects-puzzle-outline', component: _ObjectsPuzzleOutline2.default };
var objectsSignFilled = exports.objectsSignFilled = { name: 'objects-sign-filled', component: _ObjectsSignFilled2.default };
var objectsSignOutline = exports.objectsSignOutline = { name: 'objects-sign-outline', component: _ObjectsSignOutline2.default };
var objectsStopwatchFilled = exports.objectsStopwatchFilled = { name: 'objects-stopwatch-filled', component: _ObjectsStopwatchFilled2.default };
var objectsStopwatchOutline = exports.objectsStopwatchOutline = { name: 'objects-stopwatch-outline', component: _ObjectsStopwatchOutline2.default };
var objectsToolFilled = exports.objectsToolFilled = { name: 'objects-tool-filled', component: _ObjectsToolFilled2.default };
var objectsToolOutline = exports.objectsToolOutline = { name: 'objects-tool-outline', component: _ObjectsToolOutline2.default };
var objectsTrashFilled = exports.objectsTrashFilled = { name: 'objects-trash-filled', component: _ObjectsTrashFilled2.default };
var objectsTrashOutline = exports.objectsTrashOutline = { name: 'objects-trash-outline', component: _ObjectsTrashOutline2.default };
var objectsVideocameraFilled = exports.objectsVideocameraFilled = { name: 'objects-videocamera-filled', component: _ObjectsVideocameraFilled2.default };
var objectsVideocameraOutline = exports.objectsVideocameraOutline = { name: 'objects-videocamera-outline', component: _ObjectsVideocameraOutline2.default };
var objectsWandOutline = exports.objectsWandOutline = { name: 'objects-wand-outline', component: _ObjectsWandOutline2.default };
var placesHomeFilled = exports.placesHomeFilled = { name: 'places-home-filled', component: _PlacesHomeFilled2.default };
var placesHomeOutline = exports.placesHomeOutline = { name: 'places-home-outline', component: _PlacesHomeOutline2.default };
var placesStoreOutline = exports.placesStoreOutline = { name: 'places-store-outline', component: _PlacesStoreOutline2.default };
var securityFirewallOutline = exports.securityFirewallOutline = { name: 'security-firewall-outline', component: _SecurityFirewallOutline2.default };
var securityShieldAlertFilled = exports.securityShieldAlertFilled = { name: 'security-shield-alert-filled', component: _SecurityShieldAlertFilled2.default };
var securityShieldAlertOutline = exports.securityShieldAlertOutline = { name: 'security-shield-alert-outline', component: _SecurityShieldAlertOutline2.default };
var securityShieldFilled = exports.securityShieldFilled = { name: 'security-shield-filled', component: _SecurityShieldFilled2.default };
var securityShieldLockFilled = exports.securityShieldLockFilled = { name: 'security-shield-lock-filled', component: _SecurityShieldLockFilled2.default };
var securityShieldLockOpenFilled = exports.securityShieldLockOpenFilled = { name: 'security-shield-lock-open-filled', component: _SecurityShieldLockOpenFilled2.default };
var securityShieldLockOpenOutline = exports.securityShieldLockOpenOutline = { name: 'security-shield-lock-open-outline', component: _SecurityShieldLockOpenOutline2.default };
var securityShieldLockOutline = exports.securityShieldLockOutline = { name: 'security-shield-lock-outline', component: _SecurityShieldLockOutline2.default };
var securityShieldOutline = exports.securityShieldOutline = { name: 'security-shield-outline', component: _SecurityShieldOutline2.default };
var serverCloudFilled = exports.serverCloudFilled = { name: 'server-cloud-filled', component: _ServerCloudFilled2.default };
var serverCloudOutline = exports.serverCloudOutline = { name: 'server-cloud-outline', component: _ServerCloudOutline2.default };
var serverDatabaseFilled = exports.serverDatabaseFilled = { name: 'server-database-filled', component: _ServerDatabaseFilled2.default };
var serverDatabaseOutline = exports.serverDatabaseOutline = { name: 'server-database-outline', component: _ServerDatabaseOutline2.default };
var serverDnsFilled = exports.serverDnsFilled = { name: 'server-dns-filled', component: _ServerDnsFilled2.default };
var serverDnsOutline = exports.serverDnsOutline = { name: 'server-dns-outline', component: _ServerDnsOutline2.default };
var serverDownloadOutline = exports.serverDownloadOutline = { name: 'server-download-outline', component: _ServerDownloadOutline2.default };
var serverFtpFilled = exports.serverFtpFilled = { name: 'server-ftp-filled', component: _ServerFtpFilled2.default };
var serverFtpOutline = exports.serverFtpOutline = { name: 'server-ftp-outline', component: _ServerFtpOutline2.default };
var serverUploadOutline = exports.serverUploadOutline = { name: 'server-upload-outline', component: _ServerUploadOutline2.default };
var servicesClicLead = exports.servicesClicLead = { name: 'services-clic-lead', component: _ServicesClicLead2.default };
var servicesCloudServerPro = exports.servicesCloudServerPro = { name: 'services-cloud-server-pro', component: _ServicesCloudServerPro2.default };
var servicesCriadorDeSites = exports.servicesCriadorDeSites = { name: 'services-criador-de-sites', component: _ServicesCriadorDeSites2.default };
var servicesEmailExchange = exports.servicesEmailExchange = { name: 'services-email-exchange', component: _ServicesEmailExchange2.default };
var servicesEmailGo = exports.servicesEmailGo = { name: 'services-email-go', component: _ServicesEmailGo2.default };
var servicesEmailLocaweb = exports.servicesEmailLocaweb = { name: 'services-email-locaweb', component: _ServicesEmailLocaweb2.default };
var servicesEmailMarketing = exports.servicesEmailMarketing = { name: 'services-email-marketing', component: _ServicesEmailMarketing2.default };
var servicesGoogleWorkspace = exports.servicesGoogleWorkspace = { name: 'services-google-workspace', component: _ServicesGoogleWorkspace2.default };
var servicesHospedagemDeSites = exports.servicesHospedagemDeSites = { name: 'services-hospedagem-de-sites', component: _ServicesHospedagemDeSites2.default };
var servicesHospedagemDedicada = exports.servicesHospedagemDedicada = { name: 'services-hospedagem-dedicada', component: _ServicesHospedagemDedicada2.default };
var servicesHospedagemWordpress = exports.servicesHospedagemWordpress = { name: 'services-hospedagem-wordpress', component: _ServicesHospedagemWordpress2.default };
var servicesRegistroDeDominio = exports.servicesRegistroDeDominio = { name: 'services-registro-de-dominio', component: _ServicesRegistroDeDominio2.default };
var servicesRevenda = exports.servicesRevenda = { name: 'services-revenda', component: _ServicesRevenda2.default };
var servicesSmtp = exports.servicesSmtp = { name: 'services-smtp', component: _ServicesSmtp2.default };
var servicesSsl = exports.servicesSsl = { name: 'services-ssl', component: _ServicesSsl2.default };
var servicesVps = exports.servicesVps = { name: 'services-vps', component: _ServicesVps2.default };
var shopAddToCartFilled = exports.shopAddToCartFilled = { name: 'shop-add-to-cart-filled', component: _ShopAddToCartFilled2.default };
var shopAddToCartOutline = exports.shopAddToCartOutline = { name: 'shop-add-to-cart-outline', component: _ShopAddToCartOutline2.default };
var shopBarcodeOutline = exports.shopBarcodeOutline = { name: 'shop-barcode-outline', component: _ShopBarcodeOutline2.default };
var shopTagFilled = exports.shopTagFilled = { name: 'shop-tag-filled', component: _ShopTagFilled2.default };
var shopTagOutline = exports.shopTagOutline = { name: 'shop-tag-outline', component: _ShopTagOutline2.default };
var shopTicketFilled = exports.shopTicketFilled = { name: 'shop-ticket-filled', component: _ShopTicketFilled2.default };
var shopTicketOutline = exports.shopTicketOutline = { name: 'shop-ticket-outline', component: _ShopTicketOutline2.default };
var symbolsAdjustOutline = exports.symbolsAdjustOutline = { name: 'symbols-adjust-outline', component: _SymbolsAdjustOutline2.default };
var symbolsAlertFilled = exports.symbolsAlertFilled = { name: 'symbols-alert-filled', component: _SymbolsAlertFilled2.default };
var symbolsAlertOutline = exports.symbolsAlertOutline = { name: 'symbols-alert-outline', component: _SymbolsAlertOutline2.default };
var symbolsBarChartOutline = exports.symbolsBarChartOutline = { name: 'symbols-bar-chart-outline', component: _SymbolsBarChartOutline2.default };
var symbolsBarsLeftOutline = exports.symbolsBarsLeftOutline = { name: 'symbols-bars-left-outline', component: _SymbolsBarsLeftOutline2.default };
var symbolsBarsOutline = exports.symbolsBarsOutline = { name: 'symbols-bars-outline', component: _SymbolsBarsOutline2.default };
var symbolsBarsRightOutline = exports.symbolsBarsRightOutline = { name: 'symbols-bars-right-outline', component: _SymbolsBarsRightOutline2.default };
var symbolsBookmarkFilled = exports.symbolsBookmarkFilled = { name: 'symbols-bookmark-filled', component: _SymbolsBookmarkFilled2.default };
var symbolsBookmarkOutline = exports.symbolsBookmarkOutline = { name: 'symbols-bookmark-outline', component: _SymbolsBookmarkOutline2.default };
var symbolsBroadcastOutline = exports.symbolsBroadcastOutline = { name: 'symbols-broadcast-outline', component: _SymbolsBroadcastOutline2.default };
var symbolsCheckOutline = exports.symbolsCheckOutline = { name: 'symbols-check-outline', component: _SymbolsCheckOutline2.default };
var symbolsCheckboxIndeterminatedFilled = exports.symbolsCheckboxIndeterminatedFilled = { name: 'symbols-checkbox-indeterminated-filled', component: _SymbolsCheckboxIndeterminatedFilled2.default };
var symbolsCheckboxIndeterminatedOutline = exports.symbolsCheckboxIndeterminatedOutline = { name: 'symbols-checkbox-indeterminated-outline', component: _SymbolsCheckboxIndeterminatedOutline2.default };
var symbolsCheckboxOutline = exports.symbolsCheckboxOutline = { name: 'symbols-checkbox-outline', component: _SymbolsCheckboxOutline2.default };
var symbolsCheckboxSelectedFilled = exports.symbolsCheckboxSelectedFilled = { name: 'symbols-checkbox-selected-filled', component: _SymbolsCheckboxSelectedFilled2.default };
var symbolsCheckboxSelectedOutline = exports.symbolsCheckboxSelectedOutline = { name: 'symbols-checkbox-selected-outline', component: _SymbolsCheckboxSelectedOutline2.default };
var symbolsCircleAlertFilled = exports.symbolsCircleAlertFilled = { name: 'symbols-circle-alert-filled', component: _SymbolsCircleAlertFilled2.default };
var symbolsCircleAlertOutline = exports.symbolsCircleAlertOutline = { name: 'symbols-circle-alert-outline', component: _SymbolsCircleAlertOutline2.default };
var symbolsCircleCheckFilled = exports.symbolsCircleCheckFilled = { name: 'symbols-circle-check-filled', component: _SymbolsCircleCheckFilled2.default };
var symbolsCircleCheckOutline = exports.symbolsCircleCheckOutline = { name: 'symbols-circle-check-outline', component: _SymbolsCircleCheckOutline2.default };
var symbolsCircleCloseFilled = exports.symbolsCircleCloseFilled = { name: 'symbols-circle-close-filled', component: _SymbolsCircleCloseFilled2.default };
var symbolsCircleCloseOutline = exports.symbolsCircleCloseOutline = { name: 'symbols-circle-close-outline', component: _SymbolsCircleCloseOutline2.default };
var symbolsCircleHelpFilled = exports.symbolsCircleHelpFilled = { name: 'symbols-circle-help-filled', component: _SymbolsCircleHelpFilled2.default };
var symbolsCircleHelpOutline = exports.symbolsCircleHelpOutline = { name: 'symbols-circle-help-outline', component: _SymbolsCircleHelpOutline2.default };
var symbolsCircleInfoFilled = exports.symbolsCircleInfoFilled = { name: 'symbols-circle-info-filled', component: _SymbolsCircleInfoFilled2.default };
var symbolsCircleInfoOutline = exports.symbolsCircleInfoOutline = { name: 'symbols-circle-info-outline', component: _SymbolsCircleInfoOutline2.default };
var symbolsCirclePlusFilled = exports.symbolsCirclePlusFilled = { name: 'symbols-circle-plus-filled', component: _SymbolsCirclePlusFilled2.default };
var symbolsCirclePlusOutline = exports.symbolsCirclePlusOutline = { name: 'symbols-circle-plus-outline', component: _SymbolsCirclePlusOutline2.default };
var symbolsCircle = exports.symbolsCircle = { name: 'symbols-circle', component: _SymbolsCircle2.default };
var symbolsCloseOutline = exports.symbolsCloseOutline = { name: 'symbols-close-outline', component: _SymbolsCloseOutline2.default };
var symbolsCloudFilled = exports.symbolsCloudFilled = { name: 'symbols-cloud-filled', component: _SymbolsCloudFilled2.default };
var symbolsCloudOutline = exports.symbolsCloudOutline = { name: 'symbols-cloud-outline', component: _SymbolsCloudOutline2.default };
var symbolsCopyFilled = exports.symbolsCopyFilled = { name: 'symbols-copy-filled', component: _SymbolsCopyFilled2.default };
var symbolsCopyOutline = exports.symbolsCopyOutline = { name: 'symbols-copy-outline', component: _SymbolsCopyOutline2.default };
var symbolsDarkFilled = exports.symbolsDarkFilled = { name: 'symbols-dark-filled', component: _SymbolsDarkFilled2.default };
var symbolsDarkOutline = exports.symbolsDarkOutline = { name: 'symbols-dark-outline', component: _SymbolsDarkOutline2.default };
var symbolsDropFilled = exports.symbolsDropFilled = { name: 'symbols-drop-filled', component: _SymbolsDropFilled2.default };
var symbolsDropOutline = exports.symbolsDropOutline = { name: 'symbols-drop-outline', component: _SymbolsDropOutline2.default };
var symbolsEditOutline = exports.symbolsEditOutline = { name: 'symbols-edit-outline', component: _SymbolsEditOutline2.default };
var symbolsEyeFilled = exports.symbolsEyeFilled = { name: 'symbols-eye-filled', component: _SymbolsEyeFilled2.default };
var symbolsEyeOffFilled = exports.symbolsEyeOffFilled = { name: 'symbols-eye-off-filled', component: _SymbolsEyeOffFilled2.default };
var symbolsEyeOffOutline = exports.symbolsEyeOffOutline = { name: 'symbols-eye-off-outline', component: _SymbolsEyeOffOutline2.default };
var symbolsEyeOutline = exports.symbolsEyeOutline = { name: 'symbols-eye-outline', component: _SymbolsEyeOutline2.default };
var symbolsHeartFilled = exports.symbolsHeartFilled = { name: 'symbols-heart-filled', component: _SymbolsHeartFilled2.default };
var symbolsHeartOutline = exports.symbolsHeartOutline = { name: 'symbols-heart-outline', component: _SymbolsHeartOutline2.default };
var symbolsLightFilled = exports.symbolsLightFilled = { name: 'symbols-light-filled', component: _SymbolsLightFilled2.default };
var symbolsLightOutline = exports.symbolsLightOutline = { name: 'symbols-light-outline', component: _SymbolsLightOutline2.default };
var symbolsLikeFilled = exports.symbolsLikeFilled = { name: 'symbols-like-filled', component: _SymbolsLikeFilled2.default };
var symbolsLikeOutline = exports.symbolsLikeOutline = { name: 'symbols-like-outline', component: _SymbolsLikeOutline2.default };
var symbolsMinusOutline = exports.symbolsMinusOutline = { name: 'symbols-minus-outline', component: _SymbolsMinusOutline2.default };
var symbolsPaperPlaneRightFilled = exports.symbolsPaperPlaneRightFilled = { name: 'symbols-paper-plane-right-filled', component: _SymbolsPaperPlaneRightFilled2.default };
var symbolsPaperPlaneRightOutline = exports.symbolsPaperPlaneRightOutline = { name: 'symbols-paper-plane-right-outline', component: _SymbolsPaperPlaneRightOutline2.default };
var symbolsPaperPlaneTiltFilled = exports.symbolsPaperPlaneTiltFilled = { name: 'symbols-paper-plane-tilt-filled', component: _SymbolsPaperPlaneTiltFilled2.default };
var symbolsPaperPlaneTiltOutline = exports.symbolsPaperPlaneTiltOutline = { name: 'symbols-paper-plane-tilt-outline', component: _SymbolsPaperPlaneTiltOutline2.default };
var symbolsPercentageOutline = exports.symbolsPercentageOutline = { name: 'symbols-percentage-outline', component: _SymbolsPercentageOutline2.default };
var symbolsPieChartFilled = exports.symbolsPieChartFilled = { name: 'symbols-pie-chart-filled', component: _SymbolsPieChartFilled2.default };
var symbolsPieChartOutline = exports.symbolsPieChartOutline = { name: 'symbols-pie-chart-outline', component: _SymbolsPieChartOutline2.default };
var symbolsPlusFilled = exports.symbolsPlusFilled = { name: 'symbols-plus-filled', component: _SymbolsPlusFilled2.default };
var symbolsRadioButtonOutline = exports.symbolsRadioButtonOutline = { name: 'symbols-radio-button-outline', component: _SymbolsRadioButtonOutline2.default };
var symbolsRadioButtonSelectedOutline = exports.symbolsRadioButtonSelectedOutline = { name: 'symbols-radio-button-selected-outline', component: _SymbolsRadioButtonSelectedOutline2.default };
var symbolsRectangle = exports.symbolsRectangle = { name: 'symbols-rectangle', component: _SymbolsRectangle2.default };
var symbolsSquare = exports.symbolsSquare = { name: 'symbols-square', component: _SymbolsSquare2.default };
var symbolsStarFilled = exports.symbolsStarFilled = { name: 'symbols-star-filled', component: _SymbolsStarFilled2.default };
var symbolsStarOutline = exports.symbolsStarOutline = { name: 'symbols-star-outline', component: _SymbolsStarOutline2.default };
var symbolsWidgetFilled = exports.symbolsWidgetFilled = { name: 'symbols-widget-filled', component: _SymbolsWidgetFilled2.default };
var symbolsWidgetOutline = exports.symbolsWidgetOutline = { name: 'symbols-widget-outline', component: _SymbolsWidgetOutline2.default };
var symbolsWifiOutline = exports.symbolsWifiOutline = { name: 'symbols-wifi-outline', component: _SymbolsWifiOutline2.default };
var symbolsZoomInFilled = exports.symbolsZoomInFilled = { name: 'symbols-zoom-in-filled', component: _SymbolsZoomInFilled2.default };
var symbolsZoomInOutline = exports.symbolsZoomInOutline = { name: 'symbols-zoom-in-outline', component: _SymbolsZoomInOutline2.default };
var symbolsZoomOutFilled = exports.symbolsZoomOutFilled = { name: 'symbols-zoom-out-filled', component: _SymbolsZoomOutFilled2.default };
var symbolsZoomOutOutline = exports.symbolsZoomOutOutline = { name: 'symbols-zoom-out-outline', component: _SymbolsZoomOutOutline2.default };
var systemSystemTerminalFilled = exports.systemSystemTerminalFilled = { name: 'system-system-terminal-filled', component: _SystemSystemTerminalFilled2.default };
var userPeopleFilled = exports.userPeopleFilled = { name: 'user-people-filled', component: _UserPeopleFilled2.default };
var userPeopleOutline = exports.userPeopleOutline = { name: 'user-people-outline', component: _UserPeopleOutline2.default };
var userPersonAddFilled = exports.userPersonAddFilled = { name: 'user-person-add-filled', component: _UserPersonAddFilled2.default };
var userPersonAddOutline = exports.userPersonAddOutline = { name: 'user-person-add-outline', component: _UserPersonAddOutline2.default };
var userPersonFilled = exports.userPersonFilled = { name: 'user-person-filled', component: _UserPersonFilled2.default };
var userPersonOutline = exports.userPersonOutline = { name: 'user-person-outline', component: _UserPersonOutline2.default };
var webSystemCarouselOutline = exports.webSystemCarouselOutline = { name: 'web-system-carousel-outline', component: _WebSystemCarouselOutline2.default };
var webSystemCode = exports.webSystemCode = { name: 'web-system-code', component: _WebSystemCode2.default };
var webSystemCommand = exports.webSystemCommand = { name: 'web-system-command', component: _WebSystemCommand2.default };
var webSystemDashboardFilled = exports.webSystemDashboardFilled = { name: 'web-system-dashboard-filled', component: _WebSystemDashboardFilled2.default };
var webSystemDashboardOutline = exports.webSystemDashboardOutline = { name: 'web-system-dashboard-outline', component: _WebSystemDashboardOutline2.default };
var webSystemEnterOutline = exports.webSystemEnterOutline = { name: 'web-system-enter-outline', component: _WebSystemEnterOutline2.default };
var webSystemExitOutline = exports.webSystemExitOutline = { name: 'web-system-exit-outline', component: _WebSystemExitOutline2.default };
var webSystemExternalOutline = exports.webSystemExternalOutline = { name: 'web-system-external-outline', component: _WebSystemExternalOutline2.default };
var webSystemFaviconOutline = exports.webSystemFaviconOutline = { name: 'web-system-favicon-outline', component: _WebSystemFaviconOutline2.default };
var webSystemFormOutline = exports.webSystemFormOutline = { name: 'web-system-form-outline', component: _WebSystemFormOutline2.default };
var webSystemHierarchyOutline = exports.webSystemHierarchyOutline = { name: 'web-system-hierarchy-outline', component: _WebSystemHierarchyOutline2.default };
var webSystemLinkHorizontalOutline = exports.webSystemLinkHorizontalOutline = { name: 'web-system-link-horizontal-outline', component: _WebSystemLinkHorizontalOutline2.default };
var webSystemLinkOutline = exports.webSystemLinkOutline = { name: 'web-system-link-outline', component: _WebSystemLinkOutline2.default };
var webSystemListOutline = exports.webSystemListOutline = { name: 'web-system-list-outline', component: _WebSystemListOutline2.default };
var webSystemOption = exports.webSystemOption = { name: 'web-system-option', component: _WebSystemOption2.default };
var webSystemProgressCircleOutline = exports.webSystemProgressCircleOutline = { name: 'web-system-progress-circle-outline', component: _WebSystemProgressCircleOutline2.default };
var webSystemScaleOutline = exports.webSystemScaleOutline = { name: 'web-system-scale-outline', component: _WebSystemScaleOutline2.default };
var webSystemTerminalOutline = exports.webSystemTerminalOutline = { name: 'web-system-terminal-outline', component: _WebSystemTerminalOutline2.default };
var webSystemTouchOutline = exports.webSystemTouchOutline = { name: 'web-system-touch-outline', component: _WebSystemTouchOutline2.default };
var webSystemTrafficFilled = exports.webSystemTrafficFilled = { name: 'web-system-traffic-filled', component: _WebSystemTrafficFilled2.default };
var webSystemTrafficOutline = exports.webSystemTrafficOutline = { name: 'web-system-traffic-outline', component: _WebSystemTrafficOutline2.default };
var groups = exports.groups = { arrows: [{ name: 'arrows-arrows-out-outline', component: _ArrowsArrowsOutOutline2.default }, { name: 'arrows-bend-up-left', component: _ArrowsBendUpLeft2.default }, { name: 'arrows-bend-up-right', component: _ArrowsBendUpRight2.default }, { name: 'arrows-chevron-down-filled', component: _ArrowsChevronDownFilled2.default }, { name: 'arrows-chevron-down-outline', component: _ArrowsChevronDownOutline2.default }, { name: 'arrows-chevron-left-filled', component: _ArrowsChevronLeftFilled2.default }, { name: 'arrows-chevron-left-outline', component: _ArrowsChevronLeftOutline2.default }, { name: 'arrows-chevron-right-filled', component: _ArrowsChevronRightFilled2.default }, { name: 'arrows-chevron-right-outline', component: _ArrowsChevronRightOutline2.default }, { name: 'arrows-chevron-up-and-down-outline', component: _ArrowsChevronUpAndDownOutline2.default }, { name: 'arrows-chevron-up-filled', component: _ArrowsChevronUpFilled2.default }, { name: 'arrows-chevron-up-outline', component: _ArrowsChevronUpOutline2.default }, { name: 'arrows-circle-arrow-down-filled', component: _ArrowsCircleArrowDownFilled2.default }, { name: 'arrows-circle-arrow-down-outline', component: _ArrowsCircleArrowDownOutline2.default }, { name: 'arrows-circle-arrow-left-filled', component: _ArrowsCircleArrowLeftFilled2.default }, { name: 'arrows-circle-arrow-left-outline', component: _ArrowsCircleArrowLeftOutline2.default }, { name: 'arrows-circle-arrow-right-filled', component: _ArrowsCircleArrowRightFilled2.default }, { name: 'arrows-circle-arrow-right-outline', component: _ArrowsCircleArrowRightOutline2.default }, { name: 'arrows-circle-arrow-up-filled', component: _ArrowsCircleArrowUpFilled2.default }, { name: 'arrows-circle-arrow-up-outline', component: _ArrowsCircleArrowUpOutline2.default }, { name: 'arrows-clockwise', component: _ArrowsClockwise2.default }, { name: 'arrows-counter-clockwise', component: _ArrowsCounterClockwise2.default }, { name: 'arrows-cycle-check-outline', component: _ArrowsCycleCheckOutline2.default }, { name: 'arrows-down-outline', component: _ArrowsDownOutline2.default }, { name: 'arrows-fat-down-filled', component: _ArrowsFatDownFilled2.default }, { name: 'arrows-fat-down-outline', component: _ArrowsFatDownOutline2.default }, { name: 'arrows-fat-left-filled', component: _ArrowsFatLeftFilled2.default }, { name: 'arrows-fat-left-outline', component: _ArrowsFatLeftOutline2.default }, { name: 'arrows-fat-line-down-filled', component: _ArrowsFatLineDownFilled2.default }, { name: 'arrows-fat-line-down-outline', component: _ArrowsFatLineDownOutline2.default }, { name: 'arrows-fat-line-left-filled', component: _ArrowsFatLineLeftFilled2.default }, { name: 'arrows-fat-line-left-outline', component: _ArrowsFatLineLeftOutline2.default }, { name: 'arrows-fat-line-right-filled', component: _ArrowsFatLineRightFilled2.default }, { name: 'arrows-fat-line-right-outline', component: _ArrowsFatLineRightOutline2.default }, { name: 'arrows-fat-line-up-filled', component: _ArrowsFatLineUpFilled2.default }, { name: 'arrows-fat-line-up-outline', component: _ArrowsFatLineUpOutline2.default }, { name: 'arrows-fat-right-filled', component: _ArrowsFatRightFilled2.default }, { name: 'arrows-fat-right-outline', component: _ArrowsFatRightOutline2.default }, { name: 'arrows-fat-up-filled', component: _ArrowsFatUpFilled2.default }, { name: 'arrows-fat-up-outline', component: _ArrowsFatUpOutline2.default }, { name: 'arrows-horizontal-outline', component: _ArrowsHorizontalOutline2.default }, { name: 'arrows-left-and-right-outline', component: _ArrowsLeftAndRightOutline2.default }, { name: 'arrows-left-down', component: _ArrowsLeftDown2.default }, { name: 'arrows-left-outline', component: _ArrowsLeftOutline2.default }, { name: 'arrows-out-cardinal-outline', component: _ArrowsOutCardinalOutline2.default }, { name: 'arrows-right-outline', component: _ArrowsRightOutline2.default }, { name: 'arrows-shrink-outline', component: _ArrowsShrinkOutline2.default }, { name: 'arrows-up-outline', component: _ArrowsUpOutline2.default }, { name: 'arrows-vertical-outline', component: _ArrowsVerticalOutline2.default }], brand: [{ name: 'brand-allin', component: _BrandAllin2.default }, { name: 'brand-american-express', component: _BrandAmericanExpress2.default }, { name: 'brand-android-filled', component: _BrandAndroidFilled2.default }, { name: 'brand-apple-filled', component: _BrandAppleFilled2.default }, { name: 'brand-bitbucket-filled', component: _BrandBitbucketFilled2.default }, { name: 'brand-centos-filled', component: _BrandCentosFilled2.default }, { name: 'brand-cplug', component: _BrandCplug2.default }, { name: 'brand-credisfera', component: _BrandCredisfera2.default }, { name: 'brand-cronospainel', component: _BrandCronospainel2.default }, { name: 'brand-debian-filled', component: _BrandDebianFilled2.default }, { name: 'brand-delivery-direto', component: _BrandDeliveryDireto2.default }, { name: 'brand-desk360', component: _BrandDesk2.default }, { name: 'brand-diners-club', component: _BrandDinersClub2.default }, { name: 'brand-dooca', component: _BrandDooca2.default }, { name: 'brand-drupal-filled', component: _BrandDrupalFilled2.default }, { name: 'brand-elo-filled', component: _BrandEloFilled2.default }, { name: 'brand-etus', component: _BrandEtus2.default }, { name: 'brand-facebook-filled', component: _BrandFacebookFilled2.default }, { name: 'brand-fedora-filled', component: _BrandFedoraFilled2.default }, { name: 'brand-filezilla-filled', component: _BrandFilezillaFilled2.default }, { name: 'brand-firebase-filled', component: _BrandFirebaseFilled2.default }, { name: 'brand-git-filled', component: _BrandGitFilled2.default }, { name: 'brand-github-filled', component: _BrandGithubFilled2.default }, { name: 'brand-gitlab-filled', component: _BrandGitlabFilled2.default }, { name: 'brand-google-analytics-filled', component: _BrandGoogleAnalyticsFilled2.default }, { name: 'brand-ideris', component: _BrandIderis2.default }, { name: 'brand-instagram-filled', component: _BrandInstagramFilled2.default }, { name: 'brand-joomla-filled', component: _BrandJoomlaFilled2.default }, { name: 'brand-lamp-filled', component: _BrandLampFilled2.default }, { name: 'brand-linux-filled', component: _BrandLinuxFilled2.default }, { name: 'brand-locaweb-filled', component: _BrandLocawebFilled2.default }, { name: 'brand-mariadb-filled', component: _BrandMariadbFilled2.default }, { name: 'brand-mastercard-filled', component: _BrandMastercardFilled2.default }, { name: 'brand-mastercard-symbol-filled', component: _BrandMastercardSymbolFilled2.default }, { name: 'brand-melhorenvio', component: _BrandMelhorenvio2.default }, { name: 'brand-microsoft-filled', component: _BrandMicrosoftFilled2.default }, { name: 'brand-microsoftsqlserver-symbol-filled', component: _BrandMicrosoftsqlserverSymbolFilled2.default }, { name: 'brand-mongodb-filled', component: _BrandMongodbFilled2.default }, { name: 'brand-mysql-filled', component: _BrandMysqlFilled2.default }, { name: 'brand-mysql-outline', component: _BrandMysqlOutline2.default }, { name: 'brand-nextios', component: _BrandNextios2.default }, { name: 'brand-nginx-filled', component: _BrandNginxFilled2.default }, { name: 'brand-nodejs-filled', component: _BrandNodejsFilled2.default }, { name: 'brand-opensuse-filled', component: _BrandOpensuseFilled2.default }, { name: 'brand-outlook-outline', component: _BrandOutlookOutline2.default }, { name: 'brand-php-filled', component: _BrandPhpFilled2.default }, { name: 'brand-phpmyadmin-filled', component: _BrandPhpmyadminFilled2.default }, { name: 'brand-pix-filled', component: _BrandPixFilled2.default }, { name: 'brand-postgresql-filled', component: _BrandPostgresqlFilled2.default }, { name: 'brand-redis-filled', component: _BrandRedisFilled2.default }, { name: 'brand-samurai-experts', component: _BrandSamuraiExperts2.default }, { name: 'brand-socialminer', component: _BrandSocialminer2.default }, { name: 'brand-sourceforge-filled', component: _BrandSourceforgeFilled2.default }, { name: 'brand-sugarcrm-filled', component: _BrandSugarcrmFilled2.default }, { name: 'brand-telegram-filled', component: _BrandTelegramFilled2.default }, { name: 'brand-thunderbird-filled', component: _BrandThunderbirdFilled2.default }, { name: 'brand-tray', component: _BrandTray2.default }, { name: 'brand-ubuntu-filled', component: _BrandUbuntuFilled2.default }, { name: 'brand-vindi', component: _BrandVindi2.default }, { name: 'brand-visa-filled', component: _BrandVisaFilled2.default }, { name: 'brand-whatsapp-filled', component: _BrandWhatsappFilled2.default }, { name: 'brand-windows-filled', component: _BrandWindowsFilled2.default }, { name: 'brand-woocommerce-filled', component: _BrandWoocommerceFilled2.default }, { name: 'brand-wordpress-filled', component: _BrandWordpressFilled2.default }, { name: 'brand-yapay', component: _BrandYapay2.default }, { name: 'brand-zenphoto-filled', component: _BrandZenphotoFilled2.default }], communication: [{ name: 'communication-chat-alert-filled', component: _CommunicationChatAlertFilled2.default }, { name: 'communication-chat-alert-outline', component: _CommunicationChatAlertOutline2.default }, { name: 'communication-chat-filled', component: _CommunicationChatFilled2.default }, { name: 'communication-chat-off-filled', component: _CommunicationChatOffFilled2.default }, { name: 'communication-chat-off-outline', component: _CommunicationChatOffOutline2.default }, { name: 'communication-chat-outline', component: _CommunicationChatOutline2.default }, { name: 'communication-help-chat-filled', component: _CommunicationHelpChatFilled2.default }, { name: 'communication-help-chat-outline', component: _CommunicationHelpChatOutline2.default }, { name: 'communication-quote-filled', component: _CommunicationQuoteFilled2.default }, { name: 'communication-quote-outline', component: _CommunicationQuoteOutline2.default }], devices: [{ name: 'devices-screen-outline', component: _DevicesScreenOutline2.default }, { name: 'devices-smartphone-outline', component: _DevicesSmartphoneOutline2.default }, { name: 'devices-tablet-outline', component: _DevicesTabletOutline2.default }], dots: [{ name: 'dots-nine', component: _DotsNine2.default }, { name: 'dots-one', component: _DotsOne2.default }, { name: 'dots-six-horizontal', component: _DotsSixHorizontal2.default }, { name: 'dots-six-vertical', component: _DotsSixVertical2.default }, { name: 'dots-three-horizontal', component: _DotsThreeHorizontal2.default }, { name: 'dots-three-vertical', component: _DotsThreeVertical2.default }], editor: [{ name: 'editor-table-outline', component: _EditorTableOutline2.default }, { name: 'editor-text-align-center', component: _EditorTextAlignCenter2.default }, { name: 'editor-text-align-justify', component: _EditorTextAlignJustify2.default }, { name: 'editor-text-align-left', component: _EditorTextAlignLeft2.default }, { name: 'editor-text-align-right', component: _EditorTextAlignRight2.default }, { name: 'editor-text-bold-outline', component: _EditorTextBoldOutline2.default }, { name: 'editor-text-italic-outline', component: _EditorTextItalicOutline2.default }, { name: 'editor-title-outline', component: _EditorTitleOutline2.default }], emote: [{ name: 'emote-happy-filled', component: _EmoteHappyFilled2.default }, { name: 'emote-happy-outline', component: _EmoteHappyOutline2.default }, { name: 'emote-sad-filled', component: _EmoteSadFilled2.default }, { name: 'emote-sad-outline', component: _EmoteSadOutline2.default }], files: [{ name: 'files-check-filled', component: _FilesCheckFilled2.default }, { name: 'files-check-outline', component: _FilesCheckOutline2.default }, { name: 'files-close-filled', component: _FilesCloseFilled2.default }, { name: 'files-close-outline', component: _FilesCloseOutline2.default }, { name: 'files-file', component: _FilesFile2.default }, { name: 'files-history-filled', component: _FilesHistoryFilled2.default }, { name: 'files-history-outline', component: _FilesHistoryOutline2.default }, { name: 'files-minus-filled', component: _FilesMinusFilled2.default }, { name: 'files-minus-outline', component: _FilesMinusOutline2.default }, { name: 'files-plus-filled', component: _FilesPlusFilled2.default }, { name: 'files-plus-outline', component: _FilesPlusOutline2.default }, { name: 'files-reports-outline', component: _FilesReportsOutline2.default }, { name: 'files-search-filled', component: _FilesSearchFilled2.default }, { name: 'files-search-outline', component: _FilesSearchOutline2.default }, { name: 'files-statement-filled', component: _FilesStatementFilled2.default }, { name: 'files-statement-outline', component: _FilesStatementOutline2.default }, { name: 'files-text-file-filled', component: _FilesTextFileFilled2.default }, { name: 'files-text-file-outline', component: _FilesTextFileOutline2.default }], finance: [{ name: 'finance-cash-filled', component: _FinanceCashFilled2.default }, { name: 'finance-cash-outline', component: _FinanceCashOutline2.default }, { name: 'finance-circle-dollar-sign-filled', component: _FinanceCircleDollarSignFilled2.default }, { name: 'finance-circle-dollar-sign-outline', component: _FinanceCircleDollarSignOutline2.default }, { name: 'finance-credit-card-filled', component: _FinanceCreditCardFilled2.default }, { name: 'finance-credit-card-outline', component: _FinanceCreditCardOutline2.default }, { name: 'finance-credit-cards-filled', component: _FinanceCreditCardsFilled2.default }, { name: 'finance-credit-cards-outline', component: _FinanceCreditCardsOutline2.default }, { name: 'finance-dollar-sign-off-outline', component: _FinanceDollarSignOffOutline2.default }, { name: 'finance-dollar-sign-outline', component: _FinanceDollarSignOutline2.default }], hardware: [{ name: 'hardware-cpu-filled', component: _HardwareCpuFilled2.default }, { name: 'hardware-cpu-outline', component: _HardwareCpuOutline2.default }, { name: 'hardware-hdd-filled', component: _HardwareHddFilled2.default }, { name: 'hardware-hdd-outline', component: _HardwareHddOutline2.default }, { name: 'hardware-memory-filled', component: _HardwareMemoryFilled2.default }, { name: 'hardware-memory-outline', component: _HardwareMemoryOutline2.default }, { name: 'hardware-ssd-filled', component: _HardwareSsdFilled2.default }, { name: 'hardware-ssd-outline', component: _HardwareSsdOutline2.default }], localization: [{ name: 'localization-globe-filled', component: _LocalizationGlobeFilled2.default }, { name: 'localization-globe-outline', component: _LocalizationGlobeOutline2.default }, { name: 'localization-globe-pinned-filled', component: _LocalizationGlobePinnedFilled2.default }, { name: 'localization-globe-pinned-outline', component: _LocalizationGlobePinnedOutline2.default }, { name: 'localization-globe-plus-filled', component: _LocalizationGlobePlusFilled2.default }, { name: 'localization-globe-plus-outline', component: _LocalizationGlobePlusOutline2.default }, { name: 'localization-pin-filled', component: _LocalizationPinFilled2.default }, { name: 'localization-pin-outline', component: _LocalizationPinOutline2.default }], media: [{ name: 'media-image-expanded-filled', component: _MediaImageExpandedFilled2.default }, { name: 'media-image-expanded-outline', component: _MediaImageExpandedOutline2.default }, { name: 'media-image-filled', component: _MediaImageFilled2.default }, { name: 'media-image-outline', component: _MediaImageOutline2.default }, { name: 'media-pause-filled', component: _MediaPauseFilled2.default }, { name: 'media-pause-outline', component: _MediaPauseOutline2.default }, { name: 'media-play-filled', component: _MediaPlayFilled2.default }, { name: 'media-play-outline', component: _MediaPlayOutline2.default }, { name: 'media-volume-off-filled', component: _MediaVolumeOffFilled2.default }, { name: 'media-volume-off-outline', component: _MediaVolumeOffOutline2.default }, { name: 'media-volume-on-filled', component: _MediaVolumeOnFilled2.default }, { name: 'media-volume-on-outline', component: _MediaVolumeOnOutline2.default }], objects: [{ name: 'objects-balance-filled', component: _ObjectsBalanceFilled2.default }, { name: 'objects-balance-outline', component: _ObjectsBalanceOutline2.default }, { name: 'objects-bell-filled', component: _ObjectsBellFilled2.default }, { name: 'objects-bell-off-filled', component: _ObjectsBellOffFilled2.default }, { name: 'objects-bell-off-outline', component: _ObjectsBellOffOutline2.default }, { name: 'objects-bell-outline', component: _ObjectsBellOutline2.default }, { name: 'objects-box-filled', component: _ObjectsBoxFilled2.default }, { name: 'objects-box-outline', component: _ObjectsBoxOutline2.default }, { name: 'objects-calculator-filled', component: _ObjectsCalculatorFilled2.default }, { name: 'objects-calculator-outline', component: _ObjectsCalculatorOutline2.default }, { name: 'objects-calendar-filled', component: _ObjectsCalendarFilled2.default }, { name: 'objects-calendar-outline', component: _ObjectsCalendarOutline2.default }, { name: 'objects-camera-filled', component: _ObjectsCameraFilled2.default }, { name: 'objects-camera-outline', component: _ObjectsCameraOutline2.default }, { name: 'objects-cd-filled', component: _ObjectsCdFilled2.default }, { name: 'objects-cd-outline', component: _ObjectsCdOutline2.default }, { name: 'objects-clock-filled', component: _ObjectsClockFilled2.default }, { name: 'objects-clock-outline', component: _ObjectsClockOutline2.default }, { name: 'objects-compass-outline', component: _ObjectsCompassOutline2.default }, { name: 'objects-eraser-outline', component: _ObjectsEraserOutline2.default }, { name: 'objects-floppy-disk-filled', component: _ObjectsFloppyDiskFilled2.default }, { name: 'objects-floppy-disk-outline', component: _ObjectsFloppyDiskOutline2.default }, { name: 'objects-folder-filled', component: _ObjectsFolderFilled2.default }, { name: 'objects-folder-outline', component: _ObjectsFolderOutline2.default }, { name: 'objects-funnel-filled', component: _ObjectsFunnelFilled2.default }, { name: 'objects-funnel-outline', component: _ObjectsFunnelOutline2.default }, { name: 'objects-gear-filled', component: _ObjectsGearFilled2.default }, { name: 'objects-gear-outline', component: _ObjectsGearOutline2.default }, { name: 'objects-gift-outline', component: _ObjectsGiftOutline2.default }, { name: 'objects-headphone-filled', component: _ObjectsHeadphoneFilled2.default }, { name: 'objects-headphone-outline', component: _ObjectsHeadphoneOutline2.default }, { name: 'objects-key-outline', component: _ObjectsKeyOutline2.default }, { name: 'objects-lamp-filled', component: _ObjectsLampFilled2.default }, { name: 'objects-lamp-on-filled', component: _ObjectsLampOnFilled2.default }, { name: 'objects-lamp-on-outline', component: _ObjectsLampOnOutline2.default }, { name: 'objects-lamp-outline', component: _ObjectsLampOutline2.default }, { name: 'objects-lock-filled', component: _ObjectsLockFilled2.default }, { name: 'objects-lock-open-filled', component: _ObjectsLockOpenFilled2.default }, { name: 'objects-lock-open-outline', component: _ObjectsLockOpenOutline2.default }, { name: 'objects-lock-outline', component: _ObjectsLockOutline2.default }, { name: 'objects-magnify-outline', component: _ObjectsMagnifyOutline2.default }, { name: 'objects-mail-filled', component: _ObjectsMailFilled2.default }, { name: 'objects-mail-open-filled', component: _ObjectsMailOpenFilled2.default }, { name: 'objects-mail-open-outline', component: _ObjectsMailOpenOutline2.default }, { name: 'objects-mail-outline', component: _ObjectsMailOutline2.default }, { name: 'objects-megaphone-outline', component: _ObjectsMegaphoneOutline2.default }, { name: 'objects-microphone-filled', component: _ObjectsMicrophoneFilled2.default }, { name: 'objects-microphone-outline', component: _ObjectsMicrophoneOutline2.default }, { name: 'objects-paint-bucket-filled', component: _ObjectsPaintBucketFilled2.default }, { name: 'objects-paint-bucket-outline', component: _ObjectsPaintBucketOutline2.default }, { name: 'objects-paperclip-outline', component: _ObjectsPaperclipOutline2.default }, { name: 'objects-pencil-filled', component: _ObjectsPencilFilled2.default }, { name: 'objects-pencil-outline', component: _ObjectsPencilOutline2.default }, { name: 'objects-phone-filled', component: _ObjectsPhoneFilled2.default }, { name: 'objects-phone-outline', component: _ObjectsPhoneOutline2.default }, { name: 'objects-picker-outline', component: _ObjectsPickerOutline2.default }, { name: 'objects-printer-filled', component: _ObjectsPrinterFilled2.default }, { name: 'objects-printer-outline', component: _ObjectsPrinterOutline2.default }, { name: 'objects-puzzle-filled', component: _ObjectsPuzzleFilled2.default }, { name: 'objects-puzzle-outline', component: _ObjectsPuzzleOutline2.default }, { name: 'objects-sign-filled', component: _ObjectsSignFilled2.default }, { name: 'objects-sign-outline', component: _ObjectsSignOutline2.default }, { name: 'objects-stopwatch-filled', component: _ObjectsStopwatchFilled2.default }, { name: 'objects-stopwatch-outline', component: _ObjectsStopwatchOutline2.default }, { name: 'objects-tool-filled', component: _ObjectsToolFilled2.default }, { name: 'objects-tool-outline', component: _ObjectsToolOutline2.default }, { name: 'objects-trash-filled', component: _ObjectsTrashFilled2.default }, { name: 'objects-trash-outline', component: _ObjectsTrashOutline2.default }, { name: 'objects-videocamera-filled', component: _ObjectsVideocameraFilled2.default }, { name: 'objects-videocamera-outline', component: _ObjectsVideocameraOutline2.default }, { name: 'objects-wand-outline', component: _ObjectsWandOutline2.default }], places: [{ name: 'places-home-filled', component: _PlacesHomeFilled2.default }, { name: 'places-home-outline', component: _PlacesHomeOutline2.default }, { name: 'places-store-outline', component: _PlacesStoreOutline2.default }], security: [{ name: 'security-firewall-outline', component: _SecurityFirewallOutline2.default }, { name: 'security-shield-alert-filled', component: _SecurityShieldAlertFilled2.default }, { name: 'security-shield-alert-outline', component: _SecurityShieldAlertOutline2.default }, { name: 'security-shield-filled', component: _SecurityShieldFilled2.default }, { name: 'security-shield-lock-filled', component: _SecurityShieldLockFilled2.default }, { name: 'security-shield-lock-open-filled', component: _SecurityShieldLockOpenFilled2.default }, { name: 'security-shield-lock-open-outline', component: _SecurityShieldLockOpenOutline2.default }, { name: 'security-shield-lock-outline', component: _SecurityShieldLockOutline2.default }, { name: 'security-shield-outline', component: _SecurityShieldOutline2.default }], server: [{ name: 'server-cloud-filled', component: _ServerCloudFilled2.default }, { name: 'server-cloud-outline', component: _ServerCloudOutline2.default }, { name: 'server-database-filled', component: _ServerDatabaseFilled2.default }, { name: 'server-database-outline', component: _ServerDatabaseOutline2.default }, { name: 'server-dns-filled', component: _ServerDnsFilled2.default }, { name: 'server-dns-outline', component: _ServerDnsOutline2.default }, { name: 'server-download-outline', component: _ServerDownloadOutline2.default }, { name: 'server-ftp-filled', component: _ServerFtpFilled2.default }, { name: 'server-ftp-outline', component: _ServerFtpOutline2.default }, { name: 'server-upload-outline', component: _ServerUploadOutline2.default }], services: [{ name: 'services-clic-lead', component: _ServicesClicLead2.default }, { name: 'services-cloud-server-pro', component: _ServicesCloudServerPro2.default }, { name: 'services-criador-de-sites', component: _ServicesCriadorDeSites2.default }, { name: 'services-email-exchange', component: _ServicesEmailExchange2.default }, { name: 'services-email-go', component: _ServicesEmailGo2.default }, { name: 'services-email-locaweb', component: _ServicesEmailLocaweb2.default }, { name: 'services-email-marketing', component: _ServicesEmailMarketing2.default }, { name: 'services-google-workspace', component: _ServicesGoogleWorkspace2.default }, { name: 'services-hospedagem-de-sites', component: _ServicesHospedagemDeSites2.default }, { name: 'services-hospedagem-dedicada', component: _ServicesHospedagemDedicada2.default }, { name: 'services-hospedagem-wordpress', component: _ServicesHospedagemWordpress2.default }, { name: 'services-registro-de-dominio', component: _ServicesRegistroDeDominio2.default }, { name: 'services-revenda', component: _ServicesRevenda2.default }, { name: 'services-smtp', component: _ServicesSmtp2.default }, { name: 'services-ssl', component: _ServicesSsl2.default }, { name: 'services-vps', component: _ServicesVps2.default }], shop: [{ name: 'shop-add-to-cart-filled', component: _ShopAddToCartFilled2.default }, { name: 'shop-add-to-cart-outline', component: _ShopAddToCartOutline2.default }, { name: 'shop-barcode-outline', component: _ShopBarcodeOutline2.default }, { name: 'shop-tag-filled', component: _ShopTagFilled2.default }, { name: 'shop-tag-outline', component: _ShopTagOutline2.default }, { name: 'shop-ticket-filled', component: _ShopTicketFilled2.default }, { name: 'shop-ticket-outline', component: _ShopTicketOutline2.default }], symbols: [{ name: 'symbols-adjust-outline', component: _SymbolsAdjustOutline2.default }, { name: 'symbols-alert-filled', component: _SymbolsAlertFilled2.default }, { name: 'symbols-alert-outline', component: _SymbolsAlertOutline2.default }, { name: 'symbols-bar-chart-outline', component: _SymbolsBarChartOutline2.default }, { name: 'symbols-bars-left-outline', component: _SymbolsBarsLeftOutline2.default }, { name: 'symbols-bars-outline', component: _SymbolsBarsOutline2.default }, { name: 'symbols-bars-right-outline', component: _SymbolsBarsRightOutline2.default }, { name: 'symbols-bookmark-filled', component: _SymbolsBookmarkFilled2.default }, { name: 'symbols-bookmark-outline', component: _SymbolsBookmarkOutline2.default }, { name: 'symbols-broadcast-outline', component: _SymbolsBroadcastOutline2.default }, { name: 'symbols-check-outline', component: _SymbolsCheckOutline2.default }, { name: 'symbols-checkbox-indeterminated-filled', component: _SymbolsCheckboxIndeterminatedFilled2.default }, { name: 'symbols-checkbox-indeterminated-outline', component: _SymbolsCheckboxIndeterminatedOutline2.default }, { name: 'symbols-checkbox-outline', component: _SymbolsCheckboxOutline2.default }, { name: 'symbols-checkbox-selected-filled', component: _SymbolsCheckboxSelectedFilled2.default }, { name: 'symbols-checkbox-selected-outline', component: _SymbolsCheckboxSelectedOutline2.default }, { name: 'symbols-circle-alert-filled', component: _SymbolsCircleAlertFilled2.default }, { name: 'symbols-circle-alert-outline', component: _SymbolsCircleAlertOutline2.default }, { name: 'symbols-circle-check-filled', component: _SymbolsCircleCheckFilled2.default }, { name: 'symbols-circle-check-outline', component: _SymbolsCircleCheckOutline2.default }, { name: 'symbols-circle-close-filled', component: _SymbolsCircleCloseFilled2.default }, { name: 'symbols-circle-close-outline', component: _SymbolsCircleCloseOutline2.default }, { name: 'symbols-circle-help-filled', component: _SymbolsCircleHelpFilled2.default }, { name: 'symbols-circle-help-outline', component: _SymbolsCircleHelpOutline2.default }, { name: 'symbols-circle-info-filled', component: _SymbolsCircleInfoFilled2.default }, { name: 'symbols-circle-info-outline', component: _SymbolsCircleInfoOutline2.default }, { name: 'symbols-circle-plus-filled', component: _SymbolsCirclePlusFilled2.default }, { name: 'symbols-circle-plus-outline', component: _SymbolsCirclePlusOutline2.default }, { name: 'symbols-circle', component: _SymbolsCircle2.default }, { name: 'symbols-close-outline', component: _SymbolsCloseOutline2.default }, { name: 'symbols-cloud-filled', component: _SymbolsCloudFilled2.default }, { name: 'symbols-cloud-outline', component: _SymbolsCloudOutline2.default }, { name: 'symbols-copy-filled', component: _SymbolsCopyFilled2.default }, { name: 'symbols-copy-outline', component: _SymbolsCopyOutline2.default }, { name: 'symbols-dark-filled', component: _SymbolsDarkFilled2.default }, { name: 'symbols-dark-outline', component: _SymbolsDarkOutline2.default }, { name: 'symbols-drop-filled', component: _SymbolsDropFilled2.default }, { name: 'symbols-drop-outline', component: _SymbolsDropOutline2.default }, { name: 'symbols-edit-outline', component: _SymbolsEditOutline2.default }, { name: 'symbols-eye-filled', component: _SymbolsEyeFilled2.default }, { name: 'symbols-eye-off-filled', component: _SymbolsEyeOffFilled2.default }, { name: 'symbols-eye-off-outline', component: _SymbolsEyeOffOutline2.default }, { name: 'symbols-eye-outline', component: _SymbolsEyeOutline2.default }, { name: 'symbols-heart-filled', component: _SymbolsHeartFilled2.default }, { name: 'symbols-heart-outline', component: _SymbolsHeartOutline2.default }, { name: 'symbols-light-filled', component: _SymbolsLightFilled2.default }, { name: 'symbols-light-outline', component: _SymbolsLightOutline2.default }, { name: 'symbols-like-filled', component: _SymbolsLikeFilled2.default }, { name: 'symbols-like-outline', component: _SymbolsLikeOutline2.default }, { name: 'symbols-minus-outline', component: _SymbolsMinusOutline2.default }, { name: 'symbols-paper-plane-right-filled', component: _SymbolsPaperPlaneRightFilled2.default }, { name: 'symbols-paper-plane-right-outline', component: _SymbolsPaperPlaneRightOutline2.default }, { name: 'symbols-paper-plane-tilt-filled', component: _SymbolsPaperPlaneTiltFilled2.default }, { name: 'symbols-paper-plane-tilt-outline', component: _SymbolsPaperPlaneTiltOutline2.default }, { name: 'symbols-percentage-outline', component: _SymbolsPercentageOutline2.default }, { name: 'symbols-pie-chart-filled', component: _SymbolsPieChartFilled2.default }, { name: 'symbols-pie-chart-outline', component: _SymbolsPieChartOutline2.default }, { name: 'symbols-plus-filled', component: _SymbolsPlusFilled2.default }, { name: 'symbols-radio-button-outline', component: _SymbolsRadioButtonOutline2.default }, { name: 'symbols-radio-button-selected-outline', component: _SymbolsRadioButtonSelectedOutline2.default }, { name: 'symbols-rectangle', component: _SymbolsRectangle2.default }, { name: 'symbols-square', component: _SymbolsSquare2.default }, { name: 'symbols-star-filled', component: _SymbolsStarFilled2.default }, { name: 'symbols-star-outline', component: _SymbolsStarOutline2.default }, { name: 'symbols-widget-filled', component: _SymbolsWidgetFilled2.default }, { name: 'symbols-widget-outline', component: _SymbolsWidgetOutline2.default }, { name: 'symbols-wifi-outline', component: _SymbolsWifiOutline2.default }, { name: 'symbols-zoom-in-filled', component: _SymbolsZoomInFilled2.default }, { name: 'symbols-zoom-in-outline', component: _SymbolsZoomInOutline2.default }, { name: 'symbols-zoom-out-filled', component: _SymbolsZoomOutFilled2.default }, { name: 'symbols-zoom-out-outline', component: _SymbolsZoomOutOutline2.default }], system: [{ name: 'system-system-terminal-filled', component: _SystemSystemTerminalFilled2.default }], user: [{ name: 'user-people-filled', component: _UserPeopleFilled2.default }, { name: 'user-people-outline', component: _UserPeopleOutline2.default }, { name: 'user-person-add-filled', component: _UserPersonAddFilled2.default }, { name: 'user-person-add-outline', component: _UserPersonAddOutline2.default }, { name: 'user-person-filled', component: _UserPersonFilled2.default }, { name: 'user-person-outline', component: _UserPersonOutline2.default }], web: [{ name: 'web-system-carousel-outline', component: _WebSystemCarouselOutline2.default }, { name: 'web-system-code', component: _WebSystemCode2.default }, { name: 'web-system-command', component: _WebSystemCommand2.default }, { name: 'web-system-dashboard-filled', component: _WebSystemDashboardFilled2.default }, { name: 'web-system-dashboard-outline', component: _WebSystemDashboardOutline2.default }, { name: 'web-system-enter-outline', component: _WebSystemEnterOutline2.default }, { name: 'web-system-exit-outline', component: _WebSystemExitOutline2.default }, { name: 'web-system-external-outline', component: _WebSystemExternalOutline2.default }, { name: 'web-system-favicon-outline', component: _WebSystemFaviconOutline2.default }, { name: 'web-system-form-outline', component: _WebSystemFormOutline2.default }, { name: 'web-system-hierarchy-outline', component: _WebSystemHierarchyOutline2.default }, { name: 'web-system-link-horizontal-outline', component: _WebSystemLinkHorizontalOutline2.default }, { name: 'web-system-link-outline', component: _WebSystemLinkOutline2.default }, { name: 'web-system-list-outline', component: _WebSystemListOutline2.default }, { name: 'web-system-option', component: _WebSystemOption2.default }, { name: 'web-system-progress-circle-outline', component: _WebSystemProgressCircleOutline2.default }, { name: 'web-system-scale-outline', component: _WebSystemScaleOutline2.default }, { name: 'web-system-terminal-outline', component: _WebSystemTerminalOutline2.default }, { name: 'web-system-touch-outline', component: _WebSystemTouchOutline2.default }, { name: 'web-system-traffic-filled', component: _WebSystemTrafficFilled2.default }, { name: 'web-system-traffic-outline', component: _WebSystemTrafficOutline2.default }] };

var vuetify = void 0;

/**
 * Função que registra um componente no Design System
 * @param icon Icone(s) exportado(s) pela lib
 */
function registerIcon() {
    if (vuetify) {
        for (var _len = arguments.length, icon = Array(_len), _key = 0; _key < _len; _key++) {
            icon[_key] = arguments[_key];
        }

        icon.forEach(function (i) {
            vuetify.framework.icons.values[i.name] = i;
        });
    }
}

exports.default = {
    install: function install(vue) {
        vuetify = vue.prototype.$vuetify;
        registerIcon.apply(undefined, [brandLocawebFilled, objectsCalendarOutline, symbolsCloseOutline, symbolsPlusFilled, symbolsDarkFilled, symbolsLightOutline, symbolsEyeOutline, symbolsEyeOffOutline, webSystemFormOutline].concat(_toConsumableArray(groups.dots), [symbolsDropOutline, symbolsMinusOutline], _toConsumableArray(groups.arrows), _toConsumableArray(groups.communication), _toConsumableArray(groups.symbols), _toConsumableArray(groups.objects)));
    }
};